var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// assets/polyfills.ts
var supported = typeof window === "undefined" ? true : "onscrollend" in window;
if (!supported) {
  let observe = function(proto, method, handler) {
    const native = proto[method];
    proto[method] = function() {
      const args = Array.prototype.slice.apply(arguments, [0]);
      native.apply(this, args);
      args.unshift(native);
      handler.apply(this, args);
    };
  }, onAddListener = function(originalFn, type, handler, options) {
    if (type != "scroll" && type != "scrollend") return;
    const scrollport = this;
    let data = observed.get(scrollport);
    if (data === void 0) {
      let timeout = 0;
      data = {
        scrollListener: /* @__PURE__ */ __name((evt) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            if (pointers.size) {
              setTimeout(data.scrollListener, 180);
            } else {
              if (scrollport) {
                scrollport.dispatchEvent(scrollendEvent);
              }
              timeout = 0;
            }
          }, 180);
        }, "scrollListener"),
        listeners: 0
        // Count of number of listeners.
      };
      originalFn.apply(scrollport, ["scroll", data.scrollListener]);
      observed.set(scrollport, data);
    }
    data.listeners++;
  }, onRemoveListener = function(originalFn, type, handler) {
    if (type != "scroll" && type != "scrollend") return;
    const scrollport = this;
    const data = observed.get(scrollport);
    if (data === void 0) return;
    data[type]--;
    if (--data.listeners > 0) return;
    originalFn.apply(scrollport, ["scroll", data.scrollListener]);
    observed.delete(scrollport);
  };
  observe2 = observe, onAddListener2 = onAddListener, onRemoveListener2 = onRemoveListener;
  __name(observe, "observe");
  __name(onAddListener, "onAddListener");
  __name(onRemoveListener, "onRemoveListener");
  const scrollendEvent = new Event("scrollend");
  const pointers = /* @__PURE__ */ new Set();
  document.addEventListener(
    "touchstart",
    (e) => {
      for (const touch of e.changedTouches) pointers.add(touch.identifier);
    },
    { passive: true }
  );
  document.addEventListener(
    "touchend",
    (e) => {
      for (const touch of e.changedTouches) pointers.delete(touch.identifier);
    },
    { passive: true }
  );
  document.addEventListener(
    "touchcancel",
    (e) => {
      for (const touch of e.changedTouches) pointers.delete(touch.identifier);
    },
    { passive: true }
  );
  const observed = /* @__PURE__ */ new WeakMap();
  observe(Element.prototype, "addEventListener", onAddListener);
  observe(window, "addEventListener", onAddListener);
  observe(document, "addEventListener", onAddListener);
  observe(Element.prototype, "removeEventListener", onRemoveListener);
  observe(window, "removeEventListener", onRemoveListener);
  observe(document, "removeEventListener", onRemoveListener);
}
var observe2;
var onAddListener2;
var onRemoveListener2;

// assets/css-autoprefixer.ts
var initCSSAutoPrefixer = /* @__PURE__ */ __name(() => {
  const needsAutoprefixing = /* @__PURE__ */ __name(() => {
    const testElem = document.createElement("div");
    testElem.style.userSelect = "none";
    testElem.style.backdropFilter = "blur(10px)";
    testElem.style.appearance = "none";
    testElem.style.clipPath = "circle(50%)";
    return testElem.style.userSelect !== "none" || testElem.style.backdropFilter !== "blur(10px)" || testElem.style.appearance !== "none" || testElem.style.clipPath !== "circle(50%)";
  }, "needsAutoprefixing");
  const isOldBrowser = /* @__PURE__ */ __name(() => {
    const ua = navigator.userAgent;
    const isOldiOS = /iP(hone|od|ad)/.test(ua) && /Version\/(12|13|14).*Safari/.test(ua);
    const isOldSamsung = /SamsungBrowser\/([0-9]+)/.test(ua) && parseInt(ua.match(/SamsungBrowser\/([0-9]+)/)[1], 10) < 15;
    const isOldAndroid = /Android/.test(ua) && (/Chrome\/([0-9]+)/.test(ua) && parseInt(ua.match(/Chrome\/([0-9]+)/)[1], 10) < 90 || /Firefox\/([0-9]+)/.test(ua) && parseInt(ua.match(/Firefox\/([0-9]+)/)[1], 10) < 85 || /wv/.test(ua));
    return isOldiOS || isOldSamsung || isOldAndroid || needsAutoprefixing();
  }, "isOldBrowser");
  const loadAutoprefixerForOldBrowsers = /* @__PURE__ */ __name(async () => {
    if (!isOldBrowser()) {
      return;
    }
    try {
      const postcss = (await import("https://jspm.dev/postcss@8.1.10")).default;
      const autoprefixer = (await import("https://jspm.dev/autoprefixer@10.0.2")).default;
      const processStylesWithAutoprefixer = /* @__PURE__ */ __name(async () => {
        const styleTags = document.querySelectorAll("style");
        for (const styleTag of styleTags) {
          const css = styleTag.textContent;
          try {
            const result = await postcss([
              autoprefixer({
                overrideBrowserslist: [
                  "iOS 12-14",
                  "Safari 12-14",
                  "Samsung 4-15",
                  "Android >= 6",
                  "Chrome <= 90",
                  "Firefox <= 85"
                ]
              })
            ]).process(css, { from: void 0 });
            styleTag.textContent = result.css;
          } catch (err) {
            console.error("\u274C CSS Validation - Autoprefixer Error:", err, { css });
          }
        }
      }, "processStylesWithAutoprefixer");
      processStylesWithAutoprefixer();
    } catch (error) {
      console.error("\u274C Failed to load PostCSS or Autoprefixer:", error);
    }
  }, "loadAutoprefixerForOldBrowsers");
  loadAutoprefixerForOldBrowsers();
}, "initCSSAutoPrefixer");

// assets/search.ts
var initSearch = /* @__PURE__ */ __name(() => {
  var _a;
  const query = (_a = new URL(window.location.href).searchParams.get("q")) != null ? _a : "";
  window.Alpine.store("search", {
    query
  });
  const searchStore = window.Alpine.store("search");
  Alpine.effect(() => {
    const url = new URL(window.location.href);
    url.searchParams.set("q", searchStore.query);
    if (!searchStore.query) {
      url.searchParams.delete("q");
    }
    barba.history.add(url.toString(), "barba", "replace");
  });
  window.Alpine.magic("search", () => searchStore);
}, "initSearch");

// assets/textarea.ts
var initTextarea = /* @__PURE__ */ __name(() => {
}, "initTextarea");
var _textarea = {
  init: /* @__PURE__ */ __name((label, { maxRows = null }) => {
    const state = Alpine.reactive({
      active: false,
      paddingLeft: ""
    });
    const textarea = label.querySelector("textarea");
    state.active = !!(textarea == null ? void 0 : textarea.value) && !!(label == null ? void 0 : label.textContent);
    state.paddingLeft = getComputedStyle(textarea).paddingLeft;
    Alpine.nextTick(() => resizeTextarea());
    const resizeTextarea = /* @__PURE__ */ __name(() => {
      if (!textarea) return;
      textarea.style.height = "auto";
      const style = getComputedStyle(textarea);
      const borderTop = parseInt(style.borderTopWidth) || 0;
      const borderBottom = parseInt(style.borderBottomWidth) || 0;
      const paddingTop = parseInt(style.paddingTop) || 0;
      const paddingBottom = parseInt(style.paddingBottom) || 0;
      const lineHeight = parseInt(style.lineHeight) || 20;
      const borderHeight = borderTop + borderBottom;
      const paddingHeight = paddingTop + paddingBottom;
      const maxHeight = maxRows ? maxRows * lineHeight + borderHeight + paddingHeight : Infinity;
      const newHeight = Math.min(textarea.scrollHeight + borderHeight, maxHeight);
      textarea.style.height = `${newHeight}px`;
    }, "resizeTextarea");
    return {
      textarea: state,
      resizeTextarea
    };
  }, "init")
};
window._textarea = _textarea;

// assets/accessibility.ts
var initAccessibility = /* @__PURE__ */ __name(() => {
  document.querySelectorAll(`[role="button"], [role="link"], [data-icon-handle]`).forEach((element) => {
    element.onkeydown = (event) => {
      if (element.role !== "link" && element.role !== "button") {
        return;
      }
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        event.stopPropagation();
        element.dispatchEvent(new Event("click"));
      }
    };
  });
}, "initAccessibility");

// assets/back-in-stock-notification.ts
var initBackInStockNotification = /* @__PURE__ */ __name(() => {
  window.Alpine.store("backInStockNotification", {
    show: false,
    product: null,
    selected_variant: null,
    setSelectedVariant(id) {
      var _a;
      this.selected_variant = (_a = this.product.variants) == null ? void 0 : _a.find((variant) => variant.id === id);
    }
  });
  const backInStockNotificationStore = window.Alpine.store("backInStockNotification");
  window.Alpine.magic("backInStockNotification", () => backInStockNotificationStore);
  window._stores["backInStockNotification"] = backInStockNotificationStore;
}, "initBackInStockNotification");

// assets/cart.ts
var initCart = /* @__PURE__ */ __name(() => {
  var _a, _b, _c;
  window.Alpine.store("cart", {
    history: [structuredClone(window._cart_data)],
    state: {
      ...window._cart_data,
      items: (_c = (_b = (_a = window._cart_data) == null ? void 0 : _a.items) == null ? void 0 : _b.filter((item) => item.quantity).map((item, index) => ({ ...item, index }))) != null ? _c : []
    },
    upsell_products: [],
    gift_products: [],
    loading: false,
    isChanging: false,
    debounce_updates: {}
  });
  const cart = window.Alpine.store("cart");
  window.Alpine.magic("cart", () => cart);
  window._stores["cart"] = cart;
  window._cart_data = cart.state;
  const get = /* @__PURE__ */ __name(async (productAdded = false) => {
    var _a2, _b2, _c2, _d, _e, _f, _g, _h, _i;
    const data = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ sections: "data_cart_json" })
    }).then((res) => res.json()).catch((e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      cart.isChanging = false;
      return window._stores["cart"].state;
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      cart.isChanging = false;
      return window._stores["cart"].state;
    }
    const item_components = (_e = utils.JSONParse(
      (_d = (_c2 = (_b2 = (_a2 = data.sections) == null ? void 0 : _a2.data_cart_json) == null ? void 0 : _b2.replace(/<div id="shopify-section-data_cart_json" class="shopify-section"[^>]*>/gi, "")) == null ? void 0 : _c2.replace(/<\/div>[\s\n]*$/gi, "")) != null ? _d : "[]"
    )) != null ? _e : [];
    setTimeout(async () => {
      var _a3, _b3, _c3;
      if ((_b3 = (_a3 = data == null ? void 0 : data.items) == null ? void 0 : _a3.filter((item) => !item.quantity)) == null ? void 0 : _b3.length) {
        const removeItems = (_c3 = data == null ? void 0 : data.items) == null ? void 0 : _c3.filter((item) => !item.quantity);
        for (let i = 0; i < (removeItems == null ? void 0 : removeItems.length); i++) {
          const item = removeItems[i];
          const update2 = await change({ id: item.key, quantity: 0 });
        }
        await get();
      }
    }, 0);
    const newCartData = {
      ...data,
      items: (_g = (_f = data == null ? void 0 : data.items) == null ? void 0 : _f.filter((item) => item.quantity).map((item, index) => ({
        ...item,
        index,
        item_components: item_components[index]
      }))) != null ? _g : [],
      item_count: (_i = (_h = data.items) == null ? void 0 : _h.filter((item) => {
        var _a3;
        return !((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id_link);
      })) == null ? void 0 : _i.reduce((acc, item) => acc += item.quantity, 0)
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    if (productAdded) {
      document.dispatchEvent(new CustomEvent("productAddedToCart", { detail: newCartData }));
    }
    return newCartData;
  }, "get");
  const add = /* @__PURE__ */ __name(async (cartItems) => {
    cart.isChanging = true;
    const data = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify(cartItems)
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return {
        ...await get(),
        cart_error: true
      };
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return {
        ...await get(),
        cart_error: true
      };
    }
    return await get(true);
  }, "add");
  const update = /* @__PURE__ */ __name(async (updates) => {
    var _a2, _b2, _c2, _d, _e, _f, _g, _h;
    cart.isChanging = true;
    const data = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ...updates, sections: "data_cart_json" })
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return await get();
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return await get();
    }
    const item_components = utils.JSONParse(
      (_d = (_c2 = (_b2 = (_a2 = data.sections) == null ? void 0 : _a2.data_cart_json) == null ? void 0 : _b2.replace(/<div id="shopify-section-data_cart_json" class="shopify-section"[^>]*>/gi, "")) == null ? void 0 : _c2.replace(/<\/div>[\s\n]*$/gi, "")) != null ? _d : "[]"
    );
    const newCartData = {
      ...data,
      items: (_f = (_e = data == null ? void 0 : data.items) == null ? void 0 : _e.filter((item) => item.quantity).map((item, index) => ({
        ...item,
        index,
        item_components: item_components[index]
      }))) != null ? _f : [],
      item_count: (_h = (_g = data.items) == null ? void 0 : _g.filter((item) => {
        var _a3;
        return !((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id_link);
      })) == null ? void 0 : _h.reduce((acc, item) => acc += item.quantity, 0)
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    return newCartData;
  }, "update");
  const change = /* @__PURE__ */ __name(async (cartItem) => {
    var _a2, _b2, _c2, _d, _e, _f, _g, _h;
    cart.isChanging = true;
    const data = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ ...cartItem, sections: "data_cart_json" })
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return await get();
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return await get();
    }
    const item_components = utils.JSONParse(
      (_d = (_c2 = (_b2 = (_a2 = data.sections) == null ? void 0 : _a2.data_cart_json) == null ? void 0 : _b2.replace(/<div id="shopify-section-data_cart_json" class="shopify-section"[^>]*>/gi, "")) == null ? void 0 : _c2.replace(/<\/div>[\s\n]*$/gi, "")) != null ? _d : "[]"
    );
    const { items_added, items_removed, ...cart_data } = data;
    const newCartData = {
      ...cart_data,
      items: (_f = (_e = cart_data == null ? void 0 : cart_data.items) == null ? void 0 : _e.filter((item) => item.quantity).map((item, index) => ({
        ...item,
        index,
        item_components: item_components[index]
      }))) != null ? _f : [],
      item_count: (_h = (_g = data.items) == null ? void 0 : _g.filter((item) => {
        var _a3;
        return !((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id_link);
      })) == null ? void 0 : _h.reduce((acc, item) => acc += item.quantity, 0)
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    return newCartData;
  }, "change");
  const clear = /* @__PURE__ */ __name(async () => {
    const data = await fetch("/cart/clear.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
      }
    }).then((res) => res.json()).catch(async (e) => {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: "Cart Error",
        content: e.statusMessage
      });
      return await get();
    });
    if ("status" in data) {
      _stores.toast.addToast({
        type: "error",
        target: "cart",
        title: data.message,
        content: data.description
      });
      return await get();
    }
    const newCartData = {
      ...data,
      items: [],
      item_count: 0
    };
    cart.history.unshift(structuredClone(newCartData));
    cart.state = newCartData;
    if (cart.history.length > 5) {
      cart.history.pop();
    }
    cart.isChanging = false;
    return newCartData;
  }, "clear");
  const showConditionally = /* @__PURE__ */ __name((show_conditionally) => {
    if (!show_conditionally) {
      return true;
    }
    switch (show_conditionally) {
      case "always": {
        return true;
      }
      case "cart_empty": {
        return !cart.state.item_count;
      }
      case "items_added": {
        return !!cart.state.item_count;
      }
    }
  }, "showConditionally");
  const updateLineItemQuantity = /* @__PURE__ */ __name((quantity, index) => {
    var _a2, _b2, _c2, _d;
    if (!cart.state.items[index] || ((_a2 = cart.state.items[index]) == null ? void 0 : _a2.quantity) === quantity || cart.state.items.length !== ((_b2 = _stores.cart) == null ? void 0 : _b2.history[0].items.length)) {
      return;
    }
    cart.state.items[index].quantity = Math.max(0, quantity);
    cart.state.item_count = (_d = (_c2 = cart.state.items) == null ? void 0 : _c2.filter((item) => {
      var _a3;
      return !((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id_link);
    })) == null ? void 0 : _d.reduce((acc, item) => acc += item.quantity, 0);
    cart.state.total_price = cart.state.items.reduce((acc, item) => acc += item.price * item.quantity, 0);
    cart.debounce_updates = cart.state.items.reduce((acc, item) => {
      acc[`${item.key}`] = item.quantity;
      return acc;
    }, {});
  }, "updateLineItemQuantity");
  const renderGiftProducts = /* @__PURE__ */ __name(async ($el, target_type, target, receives_quantity, allow_duplicates, line_item_card_class, hide_if_empty, content_slider) => {
    var _a2, _b2, _c2, _d, _e;
    const products = utils.JSONParse($el.getAttribute("data-gift-products"));
    content_slider == null ? void 0 : content_slider.handleResize();
    setTimeout(() => {
      content_slider == null ? void 0 : content_slider.handleResize();
    }, 50);
    const controlProducts = cart.state[target_type] >= target && ((_b2 = (_a2 = cart == null ? void 0 : cart.state) == null ? void 0 : _a2.items) == null ? void 0 : _b2.reduce(
      (acc, lineItem) => products.some((prod) => prod.id === lineItem.product_id) ? acc += lineItem.quantity : acc,
      0
    )) < receives_quantity ? (_c2 = products == null ? void 0 : products.filter((prod) => allow_duplicates || !cart.state.items.some((item) => item.product_id === prod.id))) == null ? void 0 : _c2.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i) : [];
    switch (hide_if_empty) {
      case "none":
        break;
      case "section":
        (_d = $el.closest(`.shopify-section`)) == null ? void 0 : _d.classList.toggle("!hidden", (controlProducts == null ? void 0 : controlProducts.length) === 0);
        break;
      case "container":
        (_e = $el.closest(`[data-style-id]:not([data-style-id="${$el.getAttribute("data-style-id")}"])`)) == null ? void 0 : _e.classList.toggle("!hidden", (controlProducts == null ? void 0 : controlProducts.length) === 0);
        break;
      case "block":
        $el == null ? void 0 : $el.classList.toggle("!hidden", (controlProducts == null ? void 0 : controlProducts.length) === 0);
        break;
    }
    cart.gift_products = controlProducts;
    const renderProducts = controlProducts == null ? void 0 : controlProducts.filter(
      (prod, index) => {
        var _a3, _b3;
        return prod.handle !== ((_b3 = (_a3 = $el.children) == null ? void 0 : _a3[index]) == null ? void 0 : _b3.getAttribute("data-product-handle"));
      }
    );
    if (!renderProducts.length) {
      return;
    }
    const nonProductElements = $el.querySelectorAll(":scope > :not([data-product-handle])");
    $el.innerHTML = "";
    nonProductElements.forEach((el) => {
      $el.appendChild(el);
    });
    controlProducts.forEach((prod, i, arr) => {
      var _a3;
      const node = (_a3 = document.querySelector(`[data-product-card='${line_item_card_class}']`)) == null ? void 0 : _a3.cloneNode(true);
      if (node) {
        const div = document.createElement("div");
        div.setAttribute("data-product-handle", prod.handle);
        div.setAttribute("class", `shrink-0 max-w-full w-full h-full order-[--order]`);
        div.style.setProperty("--order", `${(i + 1) * 10}`);
        node.removeAttribute(`data-product-card`);
        node.setAttribute("data-product-handle", prod.handle);
        node.setAttribute("data-product-id", `${prod.id}`);
        node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => {
          el.remove();
        });
        div.appendChild(node);
        $el.appendChild(div);
      }
    });
  }, "renderGiftProducts");
  const getDynamicTextWithFormattedPrice = /* @__PURE__ */ __name((content) => {
    var _a2;
    return (_a2 = content == null ? void 0 : content.replace(/\[([^\]]*)\]/gi, (...matches) => {
      var _a3;
      return (_a3 = matches == null ? void 0 : matches[1]) == null ? void 0 : _a3.split(".").reduce(
        (acc, selector) => {
          if (!selector || acc[0] === void 0 || acc[0] === null) {
            if (/price$/gi.test(acc[1]) && typeof acc[0] === "number") {
              return [utils.formatMoney(acc[0]), selector];
            }
            return acc;
          }
          if (acc[0] && selector in acc[0]) {
            if (/price$/gi.test(selector) && typeof acc[0][selector] === "number") {
              return [utils.formatMoney(acc[0][selector]), selector];
            }
            return [acc[0][selector], selector];
          }
          return ["", ""];
        },
        [{ cart: cart.state }, ""]
      )[0];
    })) != null ? _a2 : "";
  }, "getDynamicTextWithFormattedPrice");
  const debounceCartUpdates = window.Alpine.debounce(async () => {
    var _a2, _b2;
    const b = (_a2 = cart.history[0]) == null ? void 0 : _a2.items.reduce((acc, item) => {
      acc[`${item.key}`] = item.quantity;
      return acc;
    }, {});
    if (!utils.deepEqual(b, cart.debounce_updates) && Object.keys((_b2 = cart.debounce_updates) != null ? _b2 : {}).length) {
      cart.loading = true;
      await update({ updates: cart.debounce_updates });
      cart.debounce_updates = {};
      cart.loading = false;
    }
    cart.loading = false;
  }, 650);
  window.Alpine.effect(() => {
    var _a2, _b2;
    cart.state.item_count = (_b2 = (_a2 = cart.state.items) == null ? void 0 : _a2.filter((item) => {
      var _a3;
      return !((_a3 = item == null ? void 0 : item.properties) == null ? void 0 : _a3._p_id_link);
    })) == null ? void 0 : _b2.reduce((acc, item) => acc += item.quantity, 0);
    window._cart_data = cart.state;
  });
  window.Alpine.effect(() => {
    var _a2, _b2, _c2;
    cart.state.original_pre_selling_plan_total_price = (_a2 = cart.state.items) == null ? void 0 : _a2.reduce((acc, item) => {
      var _a3, _b3, _c3, _d, _e;
      const sp = (_a3 = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _a3.compare_at_price;
      const prod = (item == null ? void 0 : item.handle) && ((_c3 = (_b3 = window == null ? void 0 : window._products) == null ? void 0 : _b3[item == null ? void 0 : item.handle]) == null ? void 0 : _c3.compare_at_price);
      acc += item.quantity * (Math.max(sp != null ? sp : 0, prod != null ? prod : 0) > ((_d = item == null ? void 0 : item.original_price) != null ? _d : 0) ? Math.max(sp != null ? sp : 0, prod != null ? prod : 0) : (_e = item == null ? void 0 : item.original_price) != null ? _e : 0);
      return acc;
    }, 0);
    cart.state.selling_plan_discount_applications = (_c2 = (_b2 = cart.state) == null ? void 0 : _b2.items) == null ? void 0 : _c2.reduce((acc, item) => {
      var _a3, _b3, _c3, _d, _e, _f, _g, _h;
      if (!((_b3 = (_a3 = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _a3.selling_plan) == null ? void 0 : _b3.name)) {
        return acc;
      }
      const index = acc.findIndex((selling_plan) => {
        var _a4, _b4;
        return selling_plan.name === ((_b4 = (_a4 = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _a4.selling_plan) == null ? void 0 : _b4.name);
      });
      if (index !== -1) {
        acc[index].value += (((_c3 = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _c3.compare_at_price) - ((_d = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _d.price)) * (item == null ? void 0 : item.quantity);
        return acc;
      }
      acc.push({
        name: (_f = (_e = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _e.selling_plan) == null ? void 0 : _f.name,
        value: (((_g = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _g.compare_at_price) - ((_h = item == null ? void 0 : item.selling_plan_allocation) == null ? void 0 : _h.price)) * (item == null ? void 0 : item.quantity)
      });
      return acc;
    }, []);
  });
  window.Alpine.effect(() => {
    var _a2, _b2;
    if ((_b2 = Object.keys((_a2 = cart.debounce_updates) != null ? _a2 : {})) == null ? void 0 : _b2.length) {
      debounceCartUpdates();
    }
  });
  document.addEventListener("productAddedToCart", async (event) => {
    const updatedCart = cart.state;
    if (typeof window._learnq !== "undefined") {
      const cartData = {
        total_price: updatedCart.total_price / 100,
        $value: updatedCart.total_price / 100,
        total_discount: updatedCart.total_discount,
        original_total_price: updatedCart.original_total_price / 100,
        items: updatedCart.items
      };
      window._learnq.push(["track", "Added to Cart", cartData]);
    }
  });
  const initDynamicLineItemCards = /* @__PURE__ */ __name(($el, {
    line_item_card_class,
    hide_if_empty,
    order_offset = 1,
    section_id,
    block_id,
    content_slider
  }) => {
    const container = $el.parentElement;
    const cart2 = window.Alpine.store("cart");
    const modal = window.Alpine.store("modal");
    const editor = window.Alpine.store("editor");
    const renderDynamicLineItemCards = /* @__PURE__ */ __name(async () => {
      var _a2, _b2, _c2, _d, _e, _f;
      content_slider == null ? void 0 : content_slider.handleResize();
      setTimeout(() => content_slider == null ? void 0 : content_slider.handleResize, 50);
      switch (hide_if_empty) {
        case "none":
          break;
        case "section":
          (_b2 = container.closest(`.shopify-section`)) == null ? void 0 : _b2.classList.toggle("!hidden", ((_a2 = cart2.state.items) == null ? void 0 : _a2.length) === 0);
          break;
        case "container":
          (_d = container.closest(`[data-style-id]:not([data-style-id="${container.getAttribute("data-style-id")}"])`)) == null ? void 0 : _d.classList.toggle("!hidden", ((_c2 = cart2.state.items) == null ? void 0 : _c2.length) === 0);
          break;
        case "block":
          break;
      }
      const existingItems = container.querySelectorAll(`[data-render-index*="${block_id}--"]`);
      const controlProducts = (_e = cart2.state.items) == null ? void 0 : _e.filter(
        (lineItem, index) => !container.querySelector(`[data-render-index="${block_id}--${index}"][data-line-item-key="${lineItem.key}"]`)
      );
      if (!controlProducts.length && existingItems.length === ((_f = cart2.state.items) == null ? void 0 : _f.length)) {
        return;
      }
      existingItems.forEach((el) => el.remove());
      cart2.state.items.forEach((lineItem, i, arr) => {
        var _a3;
        const node = (_a3 = document.querySelector(`[data-line-item-card='${line_item_card_class}']`)) == null ? void 0 : _a3.cloneNode(true);
        if (node) {
          const div = document.createElement("div");
          div.setAttribute("data-line-item-key", lineItem.key);
          div.setAttribute("data-style-id", `${section_id}--${block_id}`);
          div.setAttribute("data-render-index", `${block_id}--${i}`);
          div.setAttribute("class", `shrink-0 max-w-full w-full order-[--order]`);
          div.style.setProperty("--order", `${(i + order_offset) * 10}`);
          node.removeAttribute(`data-line-item-card`);
          node.setAttribute("data-line-item-key", lineItem.key);
          node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => el.remove());
          div.appendChild(node);
          container.appendChild(div);
        }
      });
      content_slider == null ? void 0 : content_slider.handleResize();
    }, "renderDynamicLineItemCards");
    renderDynamicLineItemCards();
    Alpine.effect(() => {
      const show = !container.closest("[data-dynamic-modals]") || (editor == null ? void 0 : editor.select_section_id) === section_id || modal.id === "modal--cart-drawer";
      if ((cart2.state.total_price || cart2.state.item_count || cart2.state.item_count <= 0) && show) {
        renderDynamicLineItemCards();
      }
    });
  }, "initDynamicLineItemCards");
  window._cart = {
    add,
    get,
    update,
    change,
    clear,
    showConditionally,
    updateLineItemQuantity,
    getDynamicTextWithFormattedPrice,
    renderGiftProducts,
    initDynamicLineItemCards
  };
  return {
    add,
    get,
    update,
    change,
    clear,
    showConditionally,
    updateLineItemQuantity,
    getDynamicTextWithFormattedPrice,
    renderGiftProducts,
    initDynamicLineItemCards
  };
}, "initCart");

// assets/media-gallery.ts
var initMediaGallery = /* @__PURE__ */ __name(() => {
  var _a, _b;
  window.Alpine.store("mediaGallery", {
    show: false,
    media: (_b = (_a = _products[Object.keys(_products)[0]]) == null ? void 0 : _a.media) != null ? _b : [],
    index: 0,
    scrollIndex: 0,
    showGallery({ media = [], index = 0 }) {
      this.media = media;
      this.show = true;
      this.index = index;
      this.scrollIndex = index;
    }
  });
  const mediaGalleryStore = window.Alpine.store("mediaGallery");
  Alpine.effect(() => {
    if (!mediaGalleryStore.show && mediaGalleryStore.media.length) {
      mediaGalleryStore.media = [];
    }
  });
  window.Alpine.magic("mediaGallery", () => mediaGalleryStore);
  window._stores["mediaGallery"] = mediaGalleryStore;
}, "initMediaGallery");

// assets/modals.ts
var initModals = /* @__PURE__ */ __name(() => {
  const modalsContainer = document.querySelector("[data-dynamic-modals]");
  window.Alpine.store("modal", {
    id: "",
    submenu_handle: "",
    loaded: !!(modalsContainer == null ? void 0 : modalsContainer.children.length) || window.modalsLoaded,
    hoverTrigger: false,
    setId(value, hover = false) {
      this.id = value;
      this.hoverTrigger = hover;
    },
    setSubId(value, hover = false) {
      this.sub_id = value;
    }
  });
  const modalStore = window.Alpine.store("modal");
  window.Alpine.magic("modal", () => modalStore);
  window._stores["modal"] = modalStore;
  const handleKeydown = /* @__PURE__ */ __name((e) => {
    if (e.key === "Escape") {
      modalStore.setId("");
      modalStore.setSubId("");
    }
  }, "handleKeydown");
  window.Alpine.effect(() => {
    const blockScroll = (modalStore == null ? void 0 : modalStore.id) && !/^megamenu--/gi.test(modalStore == null ? void 0 : modalStore.id) && (modalStore == null ? void 0 : modalStore.id) !== "search" && (modalStore == null ? void 0 : modalStore.id) !== "account_menu";
    document.body.classList.toggle("!overflow-hidden", blockScroll);
    document.documentElement.classList.toggle("!overflow-hidden", blockScroll);
    if (modalStore == null ? void 0 : modalStore.id) {
      document.addEventListener("keydown", handleKeydown);
    }
    if (!(modalStore == null ? void 0 : modalStore.id)) {
      document.removeEventListener("keydown", handleKeydown);
    }
  });
  const initEvents = /* @__PURE__ */ __name(() => {
    document.querySelectorAll(
      `:not([data-megamenu-initialized]):where([href*="#modal--"], [href*="#popup--"], [href*="#drawer--"], [href*="#megamenu--"], [data-megamenu-handle])`
    ).forEach((link) => {
      var _a, _b, _c, _d, _e, _f, _g, _h, _i;
      const handle = (_d = link.getAttribute("data-megamenu-handle") || ((_c = (_b = (_a = link.href) == null ? void 0 : _a.replace(/.*?#/gi, "")) == null ? void 0 : _b.split("?")) == null ? void 0 : _c[0])) != null ? _d : "";
      const sub_handle = (_e = link.getAttribute("data-megamenu-submenu-handle")) != null ? _e : "";
      const hasActualLink = ((_i = (_h = (_g = (_f = link.href) == null ? void 0 : _f.replace(window.origin, "")) == null ? void 0 : _g.split("#")) == null ? void 0 : _h[0]) == null ? void 0 : _i.length) > 1;
      const target = document.querySelector(`[data-megamenu="${handle}"]`);
      const submenu_target = target == null ? void 0 : target.querySelector(`[data-megamenu-submenu="${sub_handle}"]`);
      if (handle.includes("megamenu--") && (!target || sub_handle && !submenu_target)) {
        return;
      }
      link.setAttribute("data-megamenu-initialized", "true");
      link.onclick = (e) => {
        if (hasActualLink && modalStore.id === handle && (modalStore.sub_id === sub_handle || !sub_handle)) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        if (modalStore.id === handle && (modalStore.sub_id === sub_handle || !sub_handle)) {
          if (modalStore.hoverTrigger) return;
          modalStore.setId("");
          modalStore.setSubId("");
          return;
        }
        modalStore.setId(handle);
        modalStore.setSubId(sub_handle);
      };
      const handleFocusKeydown = /* @__PURE__ */ __name((e) => {
        if (modalStore.id === handle && (e.key === " " || e.key === "Enter" || e.key === "ArrowUp")) {
          e.preventDefault();
          e.stopPropagation();
          modalStore.setId("");
          modalStore.setSubId("");
          return;
        }
        if (e.key === " " || e.key === "Enter" || e.key === "ArrowDown") {
          e.preventDefault();
          e.stopPropagation();
          modalStore.setId(handle);
          modalStore.setSubId(sub_handle);
        }
      }, "handleFocusKeydown");
      link.onfocus = (e) => {
        link.addEventListener("keydown", handleFocusKeydown);
      };
      link.onblur = (e) => {
        link.removeEventListener("keydown", handleFocusKeydown);
      };
    });
  }, "initEvents");
  const editor = window.Alpine.store("editor");
  window.Alpine.effect(() => {
    if (editor == null ? void 0 : editor.load_section_id) {
      initEvents();
    }
  });
  const exitHover = /* @__PURE__ */ __name((e) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const modal = document.querySelector(`[data-megamenu="${modalStore.id}"] [x-trap\\.noautofocus="show"]`);
    const effectBlocker = document.querySelector(`[data-megamenu-effect-block="${modalStore.id}"]`);
    const selectPopup = document.querySelector(`[x-show="show_popover"]`);
    const trigger = document.querySelector(`[href="#${modalStore.id}"]`);
    if ([...(_b = (_a = e.target) == null ? void 0 : _a.children) != null ? _b : []].some((child) => child === trigger) || ((_c = e.target) == null ? void 0 : _c.closest(`[href="#${modalStore.id}"]`)) || ((_d = e.target) == null ? void 0 : _d.closest(`[data-megamenu-effect-block*="megamenu--"]`)) || ((_e = e.target) == null ? void 0 : _e.closest(`[data-megamenu="${modalStore.id}"] [x-trap\\.noautofocus="show"]`)) || ((_f = e.target) == null ? void 0 : _f.closest(`[x-show="show_popover"]`)) || ((_g = e.target) == null ? void 0 : _g.closest(`[data-style-id="section_group__megamenu"]`)) || e.target === modal || e.target === effectBlocker || e.target === trigger || e.target === selectPopup) {
      return;
    }
    modalStore.id = "";
    modalStore.hoverTrigger = false;
  }, "exitHover");
  window.Alpine.effect(() => {
    if (modalStore.id && modalStore.hoverTrigger) {
      document.addEventListener("pointerover", exitHover);
    }
    if (!modalStore.hoverTrigger || !modalStore.id) {
      document.removeEventListener("pointerover", exitHover);
    }
  });
  const debouncedInitEvents = utils.debounce(initEvents, 10);
  const mutationObserver = new MutationObserver((e) => {
    e == null ? void 0 : e.forEach((record) => {
      var _a;
      const nodes = [];
      if (((_a = record == null ? void 0 : record.addedNodes) == null ? void 0 : _a.length) && (record == null ? void 0 : record.target) instanceof Element) {
        debouncedInitEvents();
      }
    });
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
  initEvents();
}, "initModals");

// assets/collapsible.ts
var initCollapsible = /* @__PURE__ */ __name(($el, container, defaultOpen = false) => {
  const state = window.Alpine.reactive({
    open_accordion: defaultOpen,
    opening: false,
    closing: false,
    timeout: null,
    themeEditorControl: false
  });
  const toggleOpen = /* @__PURE__ */ __name(async (forceOpen = false, forceClose = false, callback = () => {
  }) => {
    if (state.themeEditorControl) return;
    clearTimeout(state.timeout);
    if (container.scrollHeight === 0) {
      document.querySelectorAll("details > div").forEach((el) => el.scrollHeight);
      document.querySelectorAll("details > div").forEach((el) => el.scrollHeight);
    }
    if ((!state.open_accordion || forceOpen) && !forceClose) {
      if (!state.closing) {
        container.style.transitionDuration = `0ms`;
        container.style.paddingTop = "0px";
        container.style.paddingBottom = "0px";
        container.style.maxHeight = `0px`;
        container.style.transitionDuration = ``;
      }
      state.opening = true;
      state.closing = false;
      state.open_accordion = true;
      container.style.maxHeight = `${Math.max(container.scrollHeight + 15, 15)}px`;
      container.style.paddingTop = "";
      container.style.paddingBottom = "";
      state.timeout = setTimeout(() => {
        state.opening = false;
        container.style.maxHeight = `${Math.max(container.scrollHeight, 99999)}px`;
        callback();
      }, 250);
      return;
    }
    if ((state.open_accordion || forceClose) && !forceOpen) {
      if (container.style.maxHeight === `99999px`) {
        container.classList.add("!transition-none");
        container.style.maxHeight = `${Math.max(container.scrollHeight + 15, 15)}px`;
      }
      Alpine.nextTick(() => {
        container.classList.remove("!transition-none");
        container.style.paddingTop = "0px";
        container.style.paddingBottom = "0px";
        container.style.maxHeight = `0px`;
        state.opening = false;
        state.closing = true;
      });
      state.timeout = setTimeout(() => {
        if (state.closing && !state.opening) {
          state.closing = false;
          state.open_accordion = false;
          callback();
        }
      }, 210);
      return;
    }
  }, "toggleOpen");
  const closeSiblingCollapsibles = /* @__PURE__ */ __name(() => {
    const getClosestElements = /* @__PURE__ */ __name(($el2, iteration = 15) => {
      const closestElements = $el2.parentElement.querySelectorAll("details");
      if (closestElements == null ? void 0 : closestElements.length) {
        return closestElements;
      }
      if (!iteration) {
        return $el2.closest(".shopify-section").querySelectorAll("details");
      }
      return getClosestElements($el2.parentElement, iteration - 1);
    }, "getClosestElements");
    getClosestElements($el).forEach((el) => {
      var _a;
      if (el === $el) return;
      (_a = el == null ? void 0 : el._x_dataStack) == null ? void 0 : _a.forEach((proxyState) => {
        var _a2;
        if ((_a2 = proxyState == null ? void 0 : proxyState.collapsible) == null ? void 0 : _a2.open_accordion) {
          proxyState == null ? void 0 : proxyState.toggleOpen(false, true);
        }
      });
    });
  }, "closeSiblingCollapsibles");
  if (window.Shopify.designMode) {
    const editor = Alpine.store("editor");
    Alpine.effect(() => {
      const styleId = `${editor.select_section_id}--${editor.select_block_id}`;
      if ($el.getAttribute("data-style-id") === styleId || $el.parentElement.getAttribute("data-style-id") === styleId || $el.querySelector(`[data-style-id="${styleId}"]`)) {
        toggleOpen(true);
        state.themeEditorControl = true;
      } else {
        if (state.themeEditorControl) {
          state.themeEditorControl = false;
          toggleOpen(false, true);
        }
      }
    });
  }
  return {
    collapsible: state,
    toggleOpen,
    closeSiblingCollapsibles
  };
}, "initCollapsible");

// assets/content-slider.ts
var initContentSlider = /* @__PURE__ */ __name(($el, container, speed = 200, infiniteScroll = false, autoRotate = 0) => {
  var _a, _b, _c, _d, _e;
  const random_id = utils.shortUUID();
  let breakPoints = [];
  let children = [...container.children].filter((el) => el.tagName !== "STYLE").toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
  const size = children.length;
  let infinite = false;
  const markCenteredChild = /* @__PURE__ */ __name((children2) => {
    const centerX = container.scrollLeft + container.clientWidth / 2;
    let closest = null;
    let minDist = Infinity;
    children2.forEach((child) => {
      const center = (child == null ? void 0 : child.offsetLeft) + child.clientWidth / 2;
      const dist = Math.abs(center - centerX);
      if (dist < minDist) {
        minDist = dist;
        closest = child;
      }
    });
    children2.forEach((child) => {
      child.classList.toggle("centered", child === closest);
    });
  }, "markCenteredChild");
  if (infiniteScroll && !infinite) {
    const visibleWidth = container.getBoundingClientRect().width;
    const totalContentWidth = [...container.children].filter((el) => el.tagName !== "STYLE").reduce((sum, child) => sum + child.getBoundingClientRect().width, 0);
    if (totalContentWidth > visibleWidth) {
      infinite = true;
      children = (_a = [...new Array(size * 2)].map((_, index) => {
        const order_index = index - size;
        const child = children.at(order_index);
        child.style.order = `${order_index}`;
        if (order_index < 0) {
          const newChild = child.cloneNode(true);
          container.append(newChild);
          return newChild;
        }
        return child;
      })) == null ? void 0 : _a.sort((a, b) => +a.style.order - +b.style.order);
      if (container.scrollWidth < totalContentWidth) {
        requestAnimationFrame(() => {
          var _a2, _b2, _c2, _d2;
          const { scrollPaddingLeft } = (_a2 = getComputedStyle(container)) != null ? _a2 : {};
          const numberScrollPaddingLeft = +((_c2 = (_b2 = scrollPaddingLeft == null ? void 0 : scrollPaddingLeft.replace("px", "")) == null ? void 0 : _b2.replace("auto", "0")) != null ? _c2 : 0);
          container.scrollLeft = ((_d2 = children[size]) == null ? void 0 : _d2.offsetLeft) - numberScrollPaddingLeft;
          children.forEach((child) => {
            child.classList.toggle("scroll-active", +getComputedStyle(child).order === 0);
          });
        });
      } else {
        const { scrollPaddingLeft } = (_b = getComputedStyle(container)) != null ? _b : {};
        const numberScrollPaddingLeft = +((_d = (_c = scrollPaddingLeft == null ? void 0 : scrollPaddingLeft.replace("px", "")) == null ? void 0 : _c.replace("auto", "0")) != null ? _d : 0);
        container.scrollLeft = ((_e = children[size]) == null ? void 0 : _e.offsetLeft) - numberScrollPaddingLeft;
      }
    }
    children.forEach((child) => {
      child.classList.toggle("scroll-active", +getComputedStyle(child).order === 0);
    });
    markCenteredChild(children);
  }
  children.forEach((child, index) => child.setAttribute("data-index", `${index}`));
  const calculateSlideCount = /* @__PURE__ */ __name((padding = state.padding, gap = state.gap, scrollWidth = container.scrollWidth, clientWidth = container.clientWidth) => {
    var _a2, _b2, _c2, _d2, _e2, _f;
    if (scrollWidth <= clientWidth) {
      return 1;
    }
    breakPoints = [];
    const snapToSlide = (_a2 = container.classList) == null ? void 0 : _a2.contains("snap-to-slide");
    let targetElements = (_e2 = (_d2 = [...container.children]) == null ? void 0 : _d2.slice(
      0,
      Math.ceil(
        ((_b2 = container.children) == null ? void 0 : _b2.length) / +((_c2 = getComputedStyle(container).getPropertyValue("grid-template-rows").split(" ").length) != null ? _c2 : 1)
      )
    )) == null ? void 0 : _e2.filter(
      (child) => getComputedStyle(child).display !== "none" && (getComputedStyle(child).scrollSnapAlign !== "none" || snapToSlide)
    );
    targetElements = targetElements == null ? void 0 : targetElements.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    if (snapToSlide) {
      const newTargetElements = [];
      const gridColsRaw = (_f = getComputedStyle(container).getPropertyValue("--grid-cols")) == null ? void 0 : _f.trim();
      const gridCols = parseFloat(gridColsRaw) || 1;
      const slidesPerPage = Math.floor(gridCols) || 1;
      for (let i = 0; i < targetElements.length; i += slidesPerPage) {
        const el = targetElements[i];
        if (el) {
          el.style.scrollSnapAlign = "start";
          newTargetElements.push(el);
        }
      }
      targetElements = newTargetElements;
    }
    const breakPointIndex = [
      ...new Array(Math.ceil(Math.round((scrollWidth - padding) / (clientWidth - padding) * 100) / 100))
    ].reduce((acc, _, index) => {
      breakPoints[index] = (clientWidth - padding) * index + index * gap;
      if (!acc && (clientWidth - padding) * index + index * gap >= scrollWidth - padding) {
        breakPoints[index] = (clientWidth - padding) * index + (index - 1) * gap;
        return index;
      }
      return acc;
    }, 0);
    if (targetElements.length) {
      return targetElements.length;
    }
    return breakPointIndex || Math.ceil(Math.round((scrollWidth - padding) / (clientWidth - padding) * 100) / 100);
  }, "calculateSlideCount");
  const state = window.Alpine.reactive({
    random_id,
    container,
    infinite,
    rotateInterval: null,
    rotatePause: false,
    justify: getComputedStyle(container).justifyContent,
    current_index: 0,
    padding: parseInt(getComputedStyle(container).paddingLeft) * 2,
    gap: parseInt(getComputedStyle(container).gap),
    slide_count: calculateSlideCount(
      parseInt(getComputedStyle(container).paddingLeft) * 2,
      parseInt(getComputedStyle(container).gap)
    ),
    children,
    block_scroll_events: false
  });
  const handleInfiniteScroll = /* @__PURE__ */ __name((event = void 0, noRepeat = false) => {
    var _a2, _b2, _c2, _d2, _e2, _f, _g, _h, _i;
    if (state.block_scroll_events || !infinite) return;
    const { paddingLeft, paddingRight, scrollPaddingLeft } = (_a2 = getComputedStyle(container)) != null ? _a2 : {};
    const numberPaddingLeft = +((_c2 = (_b2 = paddingLeft == null ? void 0 : paddingLeft.replace("px", "")) == null ? void 0 : _b2.replace("auto", "0")) != null ? _c2 : 0);
    const numberScrollPaddingLeft = +((_e2 = (_d2 = scrollPaddingLeft == null ? void 0 : scrollPaddingLeft.replace("px", "")) == null ? void 0 : _d2.replace("auto", "0")) != null ? _e2 : 0);
    const numberPaddingRight = +((_g = (_f = paddingRight == null ? void 0 : paddingRight.replace("px", "")) == null ? void 0 : _f.replace("auto", "0")) != null ? _g : 0);
    container.parentElement.style.setProperty("--slider-height", `${container.offsetHeight}px`);
    container.parentElement.style.setProperty(
      "--slider-width",
      `${container.clientWidth - numberPaddingLeft - numberPaddingRight}px`
    );
    const kids = [...state.children];
    const scrollLeft = container.scrollLeft + numberScrollPaddingLeft;
    const targetIndex = kids.findIndex((kid) => kid.offsetLeft - 30 < scrollLeft && (kid == null ? void 0 : kid.offsetLeft) + 30 > scrollLeft);
    if (targetIndex === -1) {
      if (!noRepeat) {
        setTimeout(() => {
          handleInfiniteScroll(void 0, true);
        }, 1e3);
      }
      return;
    }
    state.block_scroll_events = true;
    state.children = (_h = [...state.children].map((child, index) => {
      const targetOrder = index - targetIndex;
      child.style.order = targetOrder >= -size && targetOrder < size ? `${targetOrder}` : targetOrder < -size ? `${targetOrder + size * 2}` : `${targetOrder - size * 2}`;
      return child;
    })) == null ? void 0 : _h.sort((a, b) => +a.style.order - +b.style.order);
    container.scrollLeft = ((_i = state.children[size]) == null ? void 0 : _i.offsetLeft) - numberScrollPaddingLeft;
    Alpine.nextTick(() => {
      var _a3;
      state.block_scroll_events = false;
      const children2 = (_a3 = [...container.children]) == null ? void 0 : _a3.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
      );
      if (infinite && (children2 == null ? void 0 : children2.length)) {
        const targetIndex2 = children2 == null ? void 0 : children2.findIndex((child) => +child.style.order === 0);
        state.current_index = targetIndex2 >= children2.length / 2 ? targetIndex2 - children2.length / 2 : targetIndex2;
      }
    });
  }, "handleInfiniteScroll");
  const handleScroll = /* @__PURE__ */ __name(() => {
    var _a2;
    if (state.block_scroll_events) return;
    const currentIndex = breakPoints.findIndex((num) => container.scrollLeft >= num - 20 && container.scrollLeft <= num + 20);
    const closest = breakPoints.reduce((acc, num) => {
      return Math.abs(num - container.scrollLeft) < Math.abs(acc - container.scrollLeft) ? num : acc;
    }, 0);
    const closestIndex = breakPoints.findIndex((num) => closest === num);
    const activeChildren = (_a2 = [...container.children]) == null ? void 0 : _a2.filter(
      (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
    );
    const sortedActiveChildren = activeChildren == null ? void 0 : activeChildren.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    if (infinite && (sortedActiveChildren == null ? void 0 : sortedActiveChildren.length)) {
      const targetIndex = sortedActiveChildren == null ? void 0 : sortedActiveChildren.findIndex((child) => +child.style.order === 0);
      state.current_index = targetIndex >= sortedActiveChildren.length / 2 ? targetIndex - sortedActiveChildren.length / 2 : targetIndex;
      markCenteredChild(sortedActiveChildren);
      return;
    }
    if (sortedActiveChildren == null ? void 0 : sortedActiveChildren.length) {
      if (container.clientWidth + container.scrollLeft + 10 >= container.scrollWidth) {
        state.current_index = sortedActiveChildren.length - 1;
        markCenteredChild(sortedActiveChildren);
        return;
      }
      const targetIndex = sortedActiveChildren == null ? void 0 : sortedActiveChildren.findIndex((child, index) => {
        return child.offsetLeft - container.clientWidth / 3 < container.scrollLeft && child.offsetLeft + container.clientWidth / 3 > container.scrollLeft && child.offsetLeft + child.clientWidth - 10 > container.scrollLeft;
      });
      state.current_index = targetIndex === -1 ? state.current_index : targetIndex;
      sortedActiveChildren.forEach((child, index) => {
        child.classList.toggle("scroll-active", index === state.current_index);
      });
      markCenteredChild(sortedActiveChildren);
      return;
    }
    state.current_index = currentIndex !== -1 ? currentIndex : closestIndex !== -1 ? closestIndex : state.current_index;
    markCenteredChild(sortedActiveChildren);
  }, "handleScroll");
  const handleResize = /* @__PURE__ */ __name(() => {
    var _a2, _b2, _c2, _d2, _e2, _f, _g, _h, _i, _j;
    state.padding = parseInt(getComputedStyle(container).paddingLeft) * 2;
    state.gap = parseInt(getComputedStyle(container).gap);
    state.slide_count = calculateSlideCount();
    if (infiniteScroll && !infinite) {
      if (container.scrollWidth > container.clientWidth) {
        infinite = true;
        children = (_a2 = [...new Array(size * 2)].map((_, index) => {
          const order = index - size;
          const child = children.at(order);
          child.style.order = `${order}`;
          if (order < 0) {
            const newChild = child.cloneNode(true);
            container.append(newChild);
            return newChild;
          }
          return child;
        })) == null ? void 0 : _a2.sort((a, b) => +a.style.order - +b.style.order);
        const { scrollPaddingLeft } = (_b2 = getComputedStyle(container)) != null ? _b2 : {};
        const numberScrollPaddingLeft = +((_d2 = (_c2 = scrollPaddingLeft == null ? void 0 : scrollPaddingLeft.replace("px", "")) == null ? void 0 : _c2.replace("auto", "0")) != null ? _d2 : 0);
        container.scrollLeft = ((_e2 = children[size]) == null ? void 0 : _e2.offsetLeft) - numberScrollPaddingLeft;
      }
      children.forEach((child, index) => child.setAttribute("data-index", `${index}`));
    }
    const { paddingLeft, paddingRight } = (_f = getComputedStyle(container)) != null ? _f : {};
    container.parentElement.style.setProperty("--slider-height", `${container.offsetHeight}px`);
    container.parentElement.style.setProperty(
      "--slider-width",
      `${container.clientWidth - +((_h = (_g = paddingLeft == null ? void 0 : paddingLeft.replace("px", "")) == null ? void 0 : _g.replace("auto", "0")) != null ? _h : 0) - +((_j = (_i = paddingRight == null ? void 0 : paddingRight.replace("px", "")) == null ? void 0 : _i.replace("auto", "0")) != null ? _j : 0)}px`
    );
    if (state.justify === "center") {
      container.classList.toggle("!justify-start", container.scrollWidth > container.clientWidth);
      handleScroll();
    }
  }, "handleResize");
  const scrollToIndex = /* @__PURE__ */ __name((index, scrollDuration = speed) => {
    var _a2, _b2, _c2, _d2;
    container.classList.remove("snap-x");
    state.block_scroll_events = true;
    const activeChildren = (_a2 = [...container.children]) == null ? void 0 : _a2.filter(
      (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
    );
    const sortedActiveChildren = activeChildren == null ? void 0 : activeChildren.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
    if (sortedActiveChildren == null ? void 0 : sortedActiveChildren.length) {
      const target = sortedActiveChildren[index];
      sortedActiveChildren.forEach((child, i) => {
        child.classList.toggle("scroll-active", i === index);
      });
      utils.scrollToX(
        scrollDuration,
        ((_b2 = target == null ? void 0 : target.offsetLeft) != null ? _b2 : 0) - +((_d2 = (_c2 = getComputedStyle(container).scrollPaddingLeft) == null ? void 0 : _c2.replace("px", "")) == null ? void 0 : _d2.replace("auto", "0")),
        container,
        () => {
          container.classList.add("snap-x");
          state.block_scroll_events = false;
          handleScroll();
          if (infinite) {
            handleInfiniteScroll();
          }
        }
      );
      return;
    }
    utils.scrollToX(scrollDuration, (container.clientWidth - state.padding) * index + index * state.gap, container, () => {
      container.classList.add("snap-x");
      state.block_scroll_events = false;
      handleScroll();
    });
  }, "scrollToIndex");
  if (state.justify === "center") {
    container.classList.toggle("!justify-start", container.scrollWidth > container.clientWidth);
    state.padding = parseInt(getComputedStyle(container).paddingLeft) * 2;
    state.gap = parseInt(getComputedStyle(container).gap);
    state.slide_count = calculateSlideCount();
    handleScroll();
  }
  if (autoRotate) {
    Alpine.effect(() => {
      if (!state.rotateInterval && !state.rotatePause) {
        state.rotateInterval = setInterval(() => {
          var _a2, _b2, _c2, _d2;
          if (infinite) {
            const target = (_a2 = [...container.children]) == null ? void 0 : _a2.find((child) => +getComputedStyle(child).order === 1);
            if (target) {
              container.classList.remove("snap-x");
              state.block_scroll_events = true;
              utils.scrollToX(
                speed,
                ((_b2 = target == null ? void 0 : target.offsetLeft) != null ? _b2 : 0) - +((_d2 = (_c2 = getComputedStyle(container).scrollPaddingLeft) == null ? void 0 : _c2.replace("px", "")) == null ? void 0 : _d2.replace("auto", "0")),
                container,
                () => {
                  container.classList.add("snap-x");
                  state.block_scroll_events = false;
                  handleScroll();
                  if (infinite) {
                    handleInfiniteScroll();
                  }
                }
              );
              return;
            }
          }
          scrollToIndex(state.current_index + 1 >= state.slide_count ? 0 : state.current_index + 1);
        }, autoRotate * 1e3);
      }
      if (state.rotateInterval && state.rotatePause) {
        clearInterval(state.rotateInterval);
        state.rotateInterval = null;
      }
    });
  }
  Alpine.nextTick(() => {
    handleScroll();
    handleInfiniteScroll();
  });
  return {
    content_slider: {
      container,
      state,
      handleInfiniteScroll,
      handleScroll,
      handleResize,
      scrollToIndex,
      calculateSlideCount
    }
  };
}, "initContentSlider");

// assets/utils.ts
var JSONParse = /* @__PURE__ */ __name((object, origin = "") => {
  if (object === void 0) {
    return null;
  }
  try {
    return JSON.parse(object);
  } catch (err) {
    return null;
  }
}, "JSONParse");
var getImageSrcSet = /* @__PURE__ */ __name((src, maxWidth) => {
  var _a, _b;
  if (!src) {
    return "";
  }
  if (src.includes("?")) {
    return (_a = [48, 96, 256, 384, 460, 640, 960, 1200, 1440, 1920, 3840].map((number, index, arr) => {
      if (maxWidth && arr[index - 1] > maxWidth) {
        return null;
      }
      return `${src}&width=${number} ${number}w`;
    })) == null ? void 0 : _a.filter((d) => !!d).join(",");
  }
  return (_b = [48, 96, 256, 384, 460, 640, 960, 1200, 1440, 1920, 3840].map((number, index, arr) => {
    if (maxWidth && arr[index - 1] > maxWidth) {
      return null;
    }
    return `${src}?width=${number} ${number}w`;
  })) == null ? void 0 : _b.filter((d) => !!d).join(",");
}, "getImageSrcSet");
var getReviewStarGradients = /* @__PURE__ */ __name((rating, position) => {
  return `url(#star-rating-${rating < position - 1 ? 0 : rating < position && rating > position - 1 ? Math.floor((rating - (position - 1)) * 100 / 25) * 25 : 100})`;
}, "getReviewStarGradients");
var pushSearchParams = /* @__PURE__ */ __name(({
  update = {},
  remove = [],
  title
}) => {
  const url = new URL(window.location.href);
  Object.entries(update).forEach(([key, value]) => {
    url.searchParams.set(key, `${value}`);
  });
  remove.forEach((key) => {
    url.searchParams.delete(key);
  });
  window.history.pushState(null, null, url);
}, "pushSearchParams");
var replaceSearchParams = /* @__PURE__ */ __name(({
  update = {},
  remove = [],
  title
}) => {
  const url = new URL(window.location.href);
  Object.entries(update).forEach(([key, value]) => {
    url.searchParams.set(key, `${value}`);
  });
  remove.forEach((key) => {
    url.searchParams.delete(key);
  });
  window.history.replaceState(null, null, url);
}, "replaceSearchParams");
var getSiblingUrl = /* @__PURE__ */ __name((handle) => {
  const url = new URL(window.location.href);
  url.pathname = /\/collections\/[^/]\/products\//gi.test(url.pathname) ? url.pathname.replace(/\/products\/[^?]*/gi, `/products/${handle}`) : `/products/${handle}`;
  url.searchParams.delete("variant");
  url.searchParams.delete("selling_plan");
  return url.toString();
}, "getSiblingUrl");
var pushUrlTarget = /* @__PURE__ */ __name((id) => {
  const url = new URL(window.location.href);
  url.hash = id;
  window.history.replaceState(null, null, url);
}, "pushUrlTarget");
var checkDomain = /* @__PURE__ */ __name(function(url) {
  if (url && (url == null ? void 0 : url.indexOf("//")) === 0) {
    url = location.protocol + url;
  }
  return url.toLowerCase().replace(/([a-z])?:\/\//, "$1").split("/")[0];
}, "checkDomain");
var isExternalURL = /* @__PURE__ */ __name(function(url) {
  if (!url || typeof url !== "string") {
    return false;
  }
  return ((url == null ? void 0 : url.indexOf(":")) > -1 || (url == null ? void 0 : url.indexOf("//")) > -1) && checkDomain(location.href) !== checkDomain(url);
}, "isExternalURL");
var transpileRichtextMetafield = /* @__PURE__ */ __name((schema) => {
  function convertSchemaToHtml(schema2) {
    let html = ``;
    if (!Array.isArray(schema2) && schema2.type === "root") {
      html += convertSchemaToHtml(schema2.children);
    }
    if (Array.isArray(schema2)) {
      schema2 == null ? void 0 : schema2.forEach((el) => {
        switch (el.type) {
          case "paragraph":
            html += buildParagraph(el);
            break;
          case "heading":
            html += buildHeading(el);
            break;
          case "list":
            html += buildList(el);
            break;
          case "list-item":
            html += buildListItem(el);
            break;
          case "link":
            html += buildLink(el);
            break;
          case "text":
            html += buildText(el);
            break;
          default:
            break;
        }
      });
    }
    return html;
  }
  __name(convertSchemaToHtml, "convertSchemaToHtml");
  function buildParagraph(el) {
    if (el == null ? void 0 : el.children) {
      return `<p>${convertSchemaToHtml(el == null ? void 0 : el.children)}</p>`;
    }
    return "";
  }
  __name(buildParagraph, "buildParagraph");
  function buildHeading(el) {
    if (el == null ? void 0 : el.children) {
      return `<h${el == null ? void 0 : el.level}>${convertSchemaToHtml(el == null ? void 0 : el.children)}</h${el == null ? void 0 : el.level}>`;
    }
    return "";
  }
  __name(buildHeading, "buildHeading");
  function buildList(el) {
    if (el == null ? void 0 : el.children) {
      if ((el == null ? void 0 : el.listType) === "ordered") {
        return `<ol>${convertSchemaToHtml(el == null ? void 0 : el.children)}</ol>`;
      } else {
        return `<ul>${convertSchemaToHtml(el == null ? void 0 : el.children)}</ul>`;
      }
    }
    return "";
  }
  __name(buildList, "buildList");
  function buildListItem(el) {
    if (el == null ? void 0 : el.children) {
      return `<li>${convertSchemaToHtml(el == null ? void 0 : el.children)}</li>`;
    }
    return "";
  }
  __name(buildListItem, "buildListItem");
  function buildLink(el) {
    return `<a href="${el == null ? void 0 : el.url}" title="${el == null ? void 0 : el.title}" target="${el == null ? void 0 : el.target}">${convertSchemaToHtml(el == null ? void 0 : el.children)}</a>`;
  }
  __name(buildLink, "buildLink");
  function buildText(el) {
    if (el == null ? void 0 : el.bold) {
      return `<strong>${el == null ? void 0 : el.value}</strong>`;
    }
    if (el == null ? void 0 : el.italic) {
      return `<em>${el == null ? void 0 : el.value}</em>`;
    }
    return el == null ? void 0 : el.value;
  }
  __name(buildText, "buildText");
  return convertSchemaToHtml(schema);
}, "transpileRichtextMetafield");
var clsx = /* @__PURE__ */ __name((...props) => {
  let i = 0;
  let tmp;
  let str = "";
  const len = props.length;
  for (; i < len; i++) {
    if (tmp = props[i]) {
      if (typeof tmp === "string") {
        str += (str && " ") + tmp;
      }
    }
  }
  return str;
}, "clsx");
var shortUUID = /* @__PURE__ */ __name(() => {
  let firstPart = Math.random() * 46656 | 0;
  let secondPart = Math.random() * 46656 | 0;
  firstPart = `000${firstPart.toString(36)}`.slice(-3);
  secondPart = `000${secondPart.toString(36)}`.slice(-3);
  return firstPart + secondPart;
}, "shortUUID");
var isEmail = /* @__PURE__ */ __name((str) => {
  if (!str) return false;
  return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(str);
}, "isEmail");
var formatMoney = /* @__PURE__ */ __name((cents, money_format, no_rounding = true) => {
  if (!cents && cents !== 0) {
    return "";
  }
  function n(t, e) {
    return void 0 === t ? e : t;
  }
  __name(n, "n");
  function o(t, e, o2, i2) {
    if (e = n(e, 2), o2 = n(o2, ","), i2 = n(i2, "."), isNaN(t) || null === t) return 0;
    const r2 = (t = (t / 100).toFixed(e)).split(".");
    return r2[0].replace(/(\\d)(?=(\\d\\d\\d)+(?!\\d))/g, `$1${o2}`) + (r2[1] ? i2 + r2[1] : "");
  }
  __name(o, "o");
  "string" === typeof cents && (cents = cents.replace(".", ""));
  let i = "";
  const r = /{{\s*(\w+)\s*}}/;
  const a = money_format || window.money_format || `\${{amount}}`;
  switch (a.match(r)[1]) {
    case "amount":
      i = o(cents, 2);
      break;
    case "amount_no_decimals": {
      if (no_rounding && +cents % 100 > 0) {
        i = o(cents, 2);
        break;
      }
      i = o(cents, 0);
      break;
    }
    case "amount_with_comma_separator":
      i = o(cents, 2, ".", ",");
      break;
    case "amount_with_space_separator":
      i = o(cents, 2, " ", ",");
      break;
    case "amount_with_period_and_space_separator":
      i = o(cents, 2, " ", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      i = o(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      i = o(cents, 0, " ");
      break;
    case "amount_with_apostrophe_separator":
      i = o(cents, 2, "'", ".");
  }
  return a.replace(r, i);
}, "formatMoney");
window["formatMoney"] = formatMoney;
var roundToIndex = /* @__PURE__ */ __name(function(x, index = 0) {
  const power = Math.pow(10, -index);
  return Math.round(x * power) / power;
}, "roundToIndex");
var easeInOutQuad = /* @__PURE__ */ __name(({ currentTime, start, change, duration }) => {
  let newCurrentTime = currentTime;
  newCurrentTime /= duration / 2;
  if (newCurrentTime < 1) {
    return change / 2 * newCurrentTime * newCurrentTime + start;
  }
  newCurrentTime -= 1;
  return -change / 2 * (newCurrentTime * (newCurrentTime - 2) - 1) + start;
}, "easeInOutQuad");
var scrollToY = /* @__PURE__ */ __name((duration, to, container = window, callback = () => {
}) => {
  const start = container instanceof HTMLElement ? container.scrollTop : container.scrollY;
  const change = to - start;
  const startDate = (/* @__PURE__ */ new Date()).getTime();
  const animateScroll = /* @__PURE__ */ __name(() => {
    const currentDate = (/* @__PURE__ */ new Date()).getTime();
    const currentTime = currentDate - startDate;
    container.scrollTo(
      0,
      easeInOutQuad({
        currentTime,
        start,
        change,
        duration
      })
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      container.scrollTo(0, to);
      callback();
    }
  }, "animateScroll");
  animateScroll();
}, "scrollToY");
var scrollToX = /* @__PURE__ */ __name((duration, to, container = window, callback = () => {
}) => {
  const start = container instanceof HTMLElement ? container.scrollLeft : container.scrollX;
  const change = to - start;
  const startDate = (/* @__PURE__ */ new Date()).getTime();
  const animateScroll = /* @__PURE__ */ __name(() => {
    const currentDate = (/* @__PURE__ */ new Date()).getTime();
    const currentTime = currentDate - startDate;
    container.scrollTo(
      easeInOutQuad({
        currentTime,
        start,
        change,
        duration
      }),
      0
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      container.scrollTo(to, 0);
      callback();
    }
  }, "animateScroll");
  animateScroll();
}, "scrollToX");
var scrollToXY = /* @__PURE__ */ __name((duration, x, y, container = window, callback = () => {
}) => {
  const startX = container instanceof HTMLElement ? container.scrollLeft : container.scrollX;
  const startY = container instanceof HTMLElement ? container.scrollTop : container.scrollY;
  const changeX = x - startX;
  const changeY = y - startY;
  const startDate = Date.now();
  const animateScroll = /* @__PURE__ */ __name(() => {
    const currentDate = Date.now();
    const currentTime = currentDate - startDate;
    container.scrollTo(
      easeInOutQuad({
        currentTime,
        start: startX,
        change: changeX,
        duration
      }),
      easeInOutQuad({
        currentTime,
        start: startY,
        change: changeY,
        duration
      })
    );
    if (currentTime < duration) {
      requestAnimationFrame(animateScroll);
    } else {
      container.scrollTo(x, y);
      callback();
    }
  }, "animateScroll");
  animateScroll();
}, "scrollToXY");
var isElementScrollable = /* @__PURE__ */ __name((element) => {
  if (!element) return false;
  const { overflowX, overflowY } = getComputedStyle(element);
  const isScrollableX = element.scrollWidth > element.clientWidth && overflowX !== "visible";
  const isScrollableY = element.scrollHeight > element.clientHeight && overflowY !== "visible";
  return isScrollableX || isScrollableY;
}, "isElementScrollable");
function getElementPosition(element) {
  const box = element.getBoundingClientRect();
  const body = document.body;
  const docEl = document.documentElement;
  const scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
  const clientTop = docEl.clientTop || body.clientTop || 0;
  const clientLeft = docEl.clientLeft || body.clientLeft || 0;
  const top = box.top + scrollTop - clientTop;
  const left = box.left + scrollLeft - clientLeft;
  return { top: Math.round(top), left: Math.round(left) };
}
__name(getElementPosition, "getElementPosition");
var getElementOffset = /* @__PURE__ */ __name((el) => {
  const rect = el.getBoundingClientRect(), scrollLeft = window.pageXOffset || document.documentElement.scrollLeft, scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}, "getElementOffset");
function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
__name(delay, "delay");
var debounce = /* @__PURE__ */ __name((callback, wait = 1) => {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => {
      callback(...args);
    }, wait);
  };
}, "debounce");
var findAllScrollableParents = /* @__PURE__ */ __name((element) => {
  const scrollableParents = [];
  let parent = element.parentElement;
  while (parent) {
    const style = window.getComputedStyle(parent);
    const overflowY = style.getPropertyValue("overflow-y");
    if (overflowY === "auto" || overflowY === "scroll") {
      scrollableParents.push(parent);
    }
    parent = parent.parentElement;
  }
  if (document.scrollingElement) {
    scrollableParents.push(document.scrollingElement);
  }
  scrollableParents.push(window);
  return scrollableParents;
}, "findAllScrollableParents");
var handlelize = /* @__PURE__ */ __name((str) => {
  str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/([^\w]+|\s+)/g, "-").replace(/--+/g, "-").replace(/(^-+|-+$)/g, "").toLowerCase();
  return str;
}, "handlelize");
var serializeForm = /* @__PURE__ */ __name((formElement) => {
  const obj = {};
  const formData = new FormData(formElement);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return obj;
}, "serializeForm");
var deepEqual = /* @__PURE__ */ __name((a, b) => {
  if (a === b) return true;
  if (a && b && typeof a === "object" && typeof b === "object") {
    if (a.constructor !== b.constructor) return false;
    let length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0; ) if (!deepEqual(a[i], b[i])) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0; ) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length; i-- !== 0; ) {
      const key = keys[i];
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  }
  return a !== a && b !== b;
}, "deepEqual");
window.clsx = clsx;
var isVisible = /* @__PURE__ */ __name((elem, isParent = false) => {
  if (!(elem instanceof Element)) {
    return false;
  }
  const style = getComputedStyle(elem);
  if (style.display === "none") return false;
  if (!isParent && style.pointerEvents === "none") return false;
  if (style.visibility !== "visible") return false;
  if (+style.opacity < 0.1) return false;
  if (elem.offsetWidth + elem.offsetHeight + elem.getBoundingClientRect().height + elem.getBoundingClientRect().width === 0) {
    return false;
  }
  if (elem.parentElement) {
    return isVisible(elem.parentElement, true);
  }
  return true;
}, "isVisible");
var isInViewport = /* @__PURE__ */ __name((element) => {
  const { y } = element.getBoundingClientRect();
  if (y > window.innerHeight || y < 0) {
    return false;
  }
  return true;
}, "isInViewport");
var getBracketInputDynamicText = /* @__PURE__ */ __name((content, object = {}) => {
  var _a;
  let returnValue = "";
  returnValue = (_a = content == null ? void 0 : content.replace(/\[([^\]]*)\]/gi, (...matches) => {
    var _a2, _b, _c, _d;
    if (!matches[1]) {
      return "";
    }
    if (/^icon\./gi.test(matches[1])) {
      return matches[0];
    }
    let result = (
      // @ts-ignore
      (_d = (_c = (_b = (_a2 = matches == null ? void 0 : matches[1]) == null ? void 0 : _a2.split(".")) == null ? void 0 : _b.reduce(
        (acc, selector, index, arr) => {
          var _a3;
          if (!selector || acc[0] === void 0 || acc[0] === null) {
            if (/price$/gi.test(acc[1]) && typeof acc[0] === "number") {
              return [utils2.formatMoney(acc[0]), selector];
            }
            if (/_at$/gi.test(acc[1]) && Date.parse(acc[0])) {
              return [new Date(acc[0]).toLocaleDateString(), selector];
            }
            if (typeof acc[0] === "string" && acc[0].includes("\xAE")) {
              return [acc[0].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
            }
            if (Array.isArray(acc[0]) && acc[0].every((val) => typeof val === "string" || typeof val === "number")) {
              return [acc[0].join(", "), selector];
            }
            return acc;
          }
          if (acc[0] && typeof acc[0] === "object" && selector in acc[0]) {
            if (/price$/gi.test(selector) && typeof acc[0][selector] === "number") {
              return [utils2.formatMoney(acc[0][selector]), selector];
            }
            if (/_at$/gi.test(selector) && Date.parse(acc[0][selector])) {
              if (arr[index + 1]) {
                return [(_a3 = window.dayjs(acc[0][selector])) == null ? void 0 : _a3.format(arr[index + 1]), selector];
              }
              return [new Date(acc[0][selector]).toLocaleDateString(), selector];
            }
            if (typeof acc[0][selector] === "string" && acc[0][selector].includes("\xAE")) {
              return [acc[0][selector].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
            }
            if (index === arr.length - 1) {
              if (Array.isArray(acc[0][selector]) && acc[0][selector].every((val) => typeof val === "string" || typeof val === "number")) {
                return [acc[0][selector].join(", "), selector];
              }
            }
            return [acc[0][selector], selector];
          }
          if (selector && typeof acc[0] === "string") {
            return acc;
          }
          return ["", ""];
        },
        [object, ""]
      )) == null ? void 0 : _c[0]) != null ? _d : ""
    );
    if (typeof result === "string" && (result == null ? void 0 : result.includes("Default Title"))) {
      result = result == null ? void 0 : result.replace("Default Title", "");
    }
    return result;
  })) != null ? _a : "";
  return returnValue;
}, "getBracketInputDynamicText");
var getBracketInputDynamicValue = /* @__PURE__ */ __name((content, object = {}) => {
  let returnValue = null;
  if (!content || typeof content !== "string") {
    return null;
  }
  content == null ? void 0 : content.replace(/\[([^\]]*)\]/gi, (...matches) => {
    var _a, _b, _c;
    if (!matches[1]) {
      return returnValue;
    }
    returnValue = (_c = (_b = (_a = matches == null ? void 0 : matches[1]) == null ? void 0 : _a.split(".")) == null ? void 0 : _b.reduce(
      (acc, selector) => {
        if (!selector || acc[0] === void 0 || acc[0] === null) {
          if (/price$/gi.test(acc[1]) && typeof acc[0] === "number") {
            return [utils2.formatMoney(acc[0]), selector];
          }
          if (/_at$/gi.test(acc[1]) && Date.parse(acc[0])) {
            return [new Date(acc[0]).toLocaleDateString(), selector];
          }
          if (typeof acc[0] === "string" && acc[0].includes("\xAE")) {
            return [acc[0].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
          }
          return acc;
        }
        if (acc[0] && selector in acc[0]) {
          if (/price$/gi.test(selector) && typeof acc[0][selector] === "number") {
            return [utils2.formatMoney(acc[0][selector]), selector];
          }
          if (/_at$/gi.test(selector) && Date.parse(acc[0][selector])) {
            return [new Date(acc[0][selector]).toLocaleDateString(), selector];
          }
          if (typeof acc[0][selector] === "string" && acc[0][selector].includes("\xAE")) {
            return [acc[0][selector].replace(/®/gi, `<sup style="font-size: 0.7em;">\xAE</sup>`), selector];
          }
          return [acc[0][selector], selector];
        }
        return ["", ""];
      },
      [object, ""]
    )) == null ? void 0 : _c[0];
    return "";
  });
  return returnValue != null ? returnValue : "";
}, "getBracketInputDynamicValue");
function unescape(htmlStr) {
  htmlStr = htmlStr.replace(/&lt;/g, "<");
  htmlStr = htmlStr.replace(/&gt;/g, ">");
  htmlStr = htmlStr.replace(/&quot;/g, '"');
  htmlStr = htmlStr.replace(/&#39;/g, "'");
  htmlStr = htmlStr.replace(/&amp;/g, "&");
  return htmlStr;
}
__name(unescape, "unescape");
function setUniformHeightById(id) {
  const elements = document.querySelectorAll(`[data-style-id="${id}"]`);
  if (elements.length === 0) {
    return;
  }
  let maxHeight = 0;
  elements.forEach((element) => {
    element.style.height = "auto";
    const elementHeight = element.offsetHeight;
    if (elementHeight > maxHeight) {
      maxHeight = elementHeight;
    }
  });
  elements.forEach((element) => {
    element.style.height = `${maxHeight}px`;
  });
}
__name(setUniformHeightById, "setUniformHeightById");
var setCookie = /* @__PURE__ */ __name((cookieName, cookieValue, cookieMinutes = 60 * 24) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  const d = /* @__PURE__ */ new Date();
  d.setTime(d.getTime() + cookieMinutes * 60 * 1e3);
  const expires = d.toUTCString();
  document.cookie = `${cookieName}=${cookieValue};expires=${expires};path=/;SameSite=Strict;`;
  return true;
}, "setCookie");
var getCookie = /* @__PURE__ */ __name((cookieName) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  const name = `${cookieName}=`;
  const cookieArray = document.cookie.split(";");
  for (let i = 0; i < cookieArray.length; i++) {
    let cookie = cookieArray[i];
    while (cookie.charAt(0) === " ") {
      cookie = cookie.substring(1);
    }
    if (cookie.indexOf(name) === 0) {
      return cookie.substring(name.length, cookie.length);
    }
  }
  return false;
}, "getCookie");
var checkCookie = /* @__PURE__ */ __name((cookieName) => {
  if (typeof window === "undefined" || typeof document === "undefined") {
    return false;
  }
  return !!cookieName && document.cookie.includes(`${cookieName}=`);
}, "checkCookie");
var removeCookie = /* @__PURE__ */ __name((cookieName) => {
  setCookie(cookieName, "", -1);
}, "removeCookie");
var focusSelectorString = `:not(.placeholder) a[href]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) button:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) textarea:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) input[type="text"]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) input[type="radio"]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) input[type="checkbox"]:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder) select:not(:where([disabled],[tabindex="-1"])),
              :not(.placeholder, [tabindex="-1"]) [tabindex]:not(:where([disabled],[tabindex="-1"])`;
var calculateHeaderHeight = /* @__PURE__ */ __name(() => {
  var _a, _b;
  document.body.style.setProperty(
    "--header-height-offset",
    `${utils2.roundToIndex((_a = document.querySelector("[data-navigation-bar]")) == null ? void 0 : _a.getBoundingClientRect().bottom, -2)}px`
  );
  document.body.classList.toggle("scrolled-down", ((_b = document.scrollingElement) == null ? void 0 : _b.scrollTop) > 10);
}, "calculateHeaderHeight");
var initYouTube = /* @__PURE__ */ __name(async () => {
  if (!window.YT && !window._youtube_initialized) {
    window._youtube_initialized = true;
    await new Promise((resolve) => {
      if (!window.onYouTubeIframeAPIReady) {
        window.onYouTubeIframeAPIReady = () => {
          resolve(true);
          document.dispatchEvent(new CustomEvent("youtube-loaded"));
        };
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        document.head.appendChild(tag);
      }
    });
  }
}, "initYouTube");
var simulateAnchorTag = /* @__PURE__ */ __name(($el) => {
  if (!$el) return;
  const modalStore = window.Alpine.store("modal");
  $el.addEventListener("click", (e) => {
    if (e.target.closest("a") || !$el.getAttribute("data-href")) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.button === 1 || e.ctrlKey || e.metaKey || $el.getAttribute("data-target") === "_blank") {
      window.open($el.getAttribute("data-href"), "_blank", "noopener,noreferrer");
    } else if (e.shiftKey) {
      window.open($el.getAttribute("data-href"), "_blank");
    } else {
      barba.go($el.getAttribute("data-href"));
      modalStore.setId("");
    }
  });
  $el.addEventListener("mousedown", (e) => {
    if (e.target.closest("a") || !$el.getAttribute("data-href")) return;
    if (e.button === 1 || e.ctrlKey || e.metaKey || $el.getAttribute("data-target") === "_blank") {
      window.open($el.getAttribute("data-href"), "_blank", "noopener,noreferrer");
      e.preventDefault();
    }
  });
  $el.addEventListener("keydown", (e) => {
    if (!$el.getAttribute("data-href")) return;
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
      if ($el.getAttribute("data-target") === "_blank") {
        window.open($el.getAttribute("data-href"), "_blank", "noopener,noreferrer");
        return;
      } else {
        barba.go($el.getAttribute("data-href"));
        modalStore.setId("");
      }
    }
  });
}, "simulateAnchorTag");
var preloadImage = /* @__PURE__ */ __name((src) => {
  if (!src) return true;
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
}, "preloadImage");
var applyStyles = /* @__PURE__ */ __name((el, styles) => {
  Object.entries(styles).forEach(([key, value]) => {
    el.style[key] = value;
  });
}, "applyStyles");
var utils2 = {
  initCollapsible,
  initContentSlider,
  initYouTube,
  simulateAnchorTag,
  clsx,
  getImageSrcSet,
  JSONParse,
  getSiblingUrl,
  calculateHeaderHeight,
  unescape,
  applyStyles,
  preloadImage,
  setCookie,
  getCookie,
  checkCookie,
  removeCookie,
  isVisible,
  isInViewport,
  getReviewStarGradients,
  transpileRichtextMetafield,
  handlelize,
  delay,
  debounce,
  scrollToY,
  scrollToX,
  scrollToXY,
  isElementScrollable,
  checkDomain,
  isExternalURL,
  getElementPosition,
  getBracketInputDynamicText,
  getBracketInputDynamicValue,
  deepEqual,
  getElementOffset,
  shortUUID,
  serializeForm,
  roundToIndex,
  formatMoney,
  findAllScrollableParents,
  isEmail,
  pushSearchParams,
  replaceSearchParams,
  pushUrlTarget,
  setUniformHeightById,
  focusSelectorString
};
var utils_default = utils2;

// assets/page-transitions.ts
var startTime = Date.now();
var initialized = false;
var firstRender = true;
var initPageTransitions = /* @__PURE__ */ __name(() => {
  var _a, _b;
  if (initialized) return;
  const rootContainer = document.querySelector("[data-content-root]");
  const scrollToTarget = /* @__PURE__ */ __name(() => {
    var _a2, _b2, _c, _d, _e, _f;
    if (window.location.hash) {
      const target = document == null ? void 0 : document.querySelector(window.location.hash);
      if (!target) return;
      if (utils.isElementScrollable(target.parentElement) && utils.isVisible(target.parentElement) && utils.isInViewport(target)) {
        if (target.parentElement.scrollWidth > target.parentElement.offsetWidth) {
          utils.scrollToXY(260, target.offsetLeft, (_a2 = target.parentElement) == null ? void 0 : _a2.scrollTop, target.parentElement);
        }
        if (target.parentElement.scrollHeight > target.parentElement.offsetHeight) {
          utils.scrollToXY(260, (_b2 = target.parentElement) == null ? void 0 : _b2.scrollLeft, target.offsetTop, target.parentElement);
        }
        return;
      }
      const targetPosition = ((_c = utils.getElementPosition(target)) == null ? void 0 : _c.top) - Math.max(0, (_f = (_e = (_d = document.querySelector(".header-sections-container")) == null ? void 0 : _d.getBoundingClientRect()) == null ? void 0 : _e.bottom) != null ? _f : 0);
      utils.scrollToY(260 + Math.abs(Math.round((window.scrollY - targetPosition) / 15)), targetPosition);
    }
  }, "scrollToTarget");
  window.Alpine.store("router", {
    pathname: rootContainer.getAttribute("data-pathname"),
    template: rootContainer.getAttribute("data-template"),
    hash: window.location.hash,
    setValue(key, value) {
      this[key] = value;
    }
  });
  const routerStore = window.Alpine.store("router");
  window.Alpine.magic("router", () => routerStore);
  window._stores["router"] = routerStore;
  window.Alpine.effect(() => {
  });
  if (window.design_mode || !window.page_transitions_enabled) {
    barba.go = (href) => {
      if (typeof href === "string" && window.location.href !== href) {
        window.location.href = href;
      }
    };
    barba.prefetch = () => {
    };
  }
  barba.use(barbaPrefetch, {
    root: document.body,
    timeout: 4e3,
    /* @ts-ignore */
    limit: 0
  });
  document.addEventListener("barba:prefetch:fulfilled", async (e) => {
    if (typeof idbKeyval !== "undefined" && !window.design_mode) {
      requestIdleCallback(
        async () => {
          var _a2, _b2;
          const url = (_a2 = e.detail.url) == null ? void 0 : _a2.replace(/(\/collections\/[^/]*\/)/gi, "/");
          const fetchResults = await barba.cache.get(url).request.then((res) => ({ data: res }));
          const div = document.createElement("div");
          div.innerHTML = (_b2 = fetchResults == null ? void 0 : fetchResults.data) == null ? void 0 : _b2.html;
          const productData = div.querySelectorAll(`[data-product-data]`);
          productData == null ? void 0 : productData.forEach(async (scriptElement) => {
            var _a3;
            const product = utils.JSONParse(scriptElement.innerHTML);
            if (product == null ? void 0 : product.handle) {
              const dbKey = `_${window.Shopify.theme.id}-product--${product.handle}`;
              _products[product.handle] = {
                recommendations_loaded_at: 0,
                related_products: [],
                complementary_products: [],
                ...await (idbKeyval == null ? void 0 : idbKeyval.get(dbKey)) || {},
                ...(_a3 = _products[product.handle]) != null ? _a3 : {},
                ...product,
                updated_at: Date.now()
              };
              await idbKeyval.set(dbKey, _products[product.handle]);
            }
          });
          await idbKeyval.set(`barba-prefetch---${startTime}-//-${url}`, fetchResults);
        },
        { timeout: 3e3 }
      );
    }
  });
  if (typeof idbKeyval !== "undefined" && window.theme_settings && !window.design_mode) {
    idbKeyval.keys().then(async (res) => {
      res.forEach(async (key) => {
        const [timestamp, cacheKey] = key.replace("barba-prefetch---", "").split("-//-");
        if (cacheKey && +timestamp > Date.now() - 1e3 * 60 * 10) {
          barba.cache.set(
            cacheKey,
            idbKeyval.get(key).then((res2) => res2.data),
            "prefetch"
          );
        } else if (cacheKey && +timestamp > 0) {
          idbKeyval.del(key);
        }
      });
      await delay(100);
      barba.timeout = window.origin.includes("127.0.0.1") ? 3e4 : 4e3;
    }).catch(async (err) => {
      await delay(100);
      barba.timeout = window.origin.includes("127.0.0.1") ? 3e4 : 4e3;
    });
  }
  const transitionOverlay = document.querySelector("[data-transition-overlay]");
  barba.init({
    prefetchIgnore: [
      "/challenge",
      "/gift_cards",
      "/search",
      "/account",
      "/account/:any",
      "/customer_identity",
      "/customer_identity/:any",
      "/apps",
      "/apps/:any",
      ...(_a = window.page_transitions_ignore) != null ? _a : []
    ].filter(Boolean),
    cacheIgnore: [
      "/challenge",
      "/gift_cards",
      "/search",
      "/account",
      "/account/:any",
      "/customer_identity",
      "/customer_identity/:any",
      "/apps",
      "/apps/:any",
      ...(_b = window.page_transitions_ignore) != null ? _b : []
    ].filter(Boolean),
    debug: true,
    /* @ts-ignore */
    cacheFirstPage: true,
    timeout: window.origin.includes("127.0.0.1") ? 3e4 : 4e3,
    // default is 2000ms,
    transitions: [
      {
        name: "opacity-transition",
        leave: /* @__PURE__ */ __name((data) => {
          transitionOverlay.classList.add("active", "out-active");
        }, "leave"),
        enter: /* @__PURE__ */ __name((data) => {
          const handleTransitionend = /* @__PURE__ */ __name(() => {
            transitionOverlay.classList.remove("out-active");
            transitionOverlay.removeEventListener("transitionend", handleTransitionend);
          }, "handleTransitionend");
          transitionOverlay.classList.remove("active");
          transitionOverlay.addEventListener("transitionend", handleTransitionend);
          window.scrollTo({
            top: 0,
            behavior: "instant"
          });
        }, "enter")
      }
    ],
    views: [
      {
        beforeLeave: /* @__PURE__ */ __name((data) => {
          var _a2, _b2;
          console.debug("beforeLeave", data);
          (_b2 = (_a2 = window._stores) == null ? void 0 : _a2.modal) == null ? void 0 : _b2.setId("");
        }, "beforeLeave"),
        namespace: "tmp",
        afterLeave(data) {
          var _a2, _b2, _c;
          console.debug("afterLeave", data);
          routerStore.setValue(
            "pathname",
            window.location.pathname
            /*data.next.container.getAttribute("data-pathname")*/
          );
          if (!((_a2 = data == null ? void 0 : data.next) == null ? void 0 : _a2.container)) {
            return;
          }
          routerStore.setValue("template", (_c = (_b2 = data == null ? void 0 : data.next) == null ? void 0 : _b2.container) == null ? void 0 : _c.getAttribute("data-template"));
        },
        beforeEnter: /* @__PURE__ */ __name((data) => {
          console.debug("beforeEnter", data);
        }, "beforeEnter"),
        afterEnter: /* @__PURE__ */ __name((data) => {
          var _a2, _b2, _c, _d, _e, _f, _g, _h, _i;
          console.debug("afterEnter", data);
          (_b2 = (_a2 = data == null ? void 0 : data.current) == null ? void 0 : _a2.container) == null ? void 0 : _b2.remove();
          window._stores["quickView"].show = false;
          (_d = (_c = window._stores) == null ? void 0 : _c.modal) == null ? void 0 : _d.setId("");
          const productDataContainer = (_e = data.next.container) == null ? void 0 : _e.querySelector("[data-product-data-init]");
          if (productDataContainer) {
            const newScriptTag = document.createElement("script");
            newScriptTag.innerHTML = productDataContainer.innerText;
            newScriptTag.setAttribute("data-product-data-init", "");
            document.head.appendChild(newScriptTag);
          }
          if (((_f = data == null ? void 0 : data.next) == null ? void 0 : _f.container) && !firstRender) {
            utils.delay(60).then(() => {
              var _a3;
              scrollToTarget();
              const html = document.createElement("html");
              html.innerHTML = (_a3 = data.next) == null ? void 0 : _a3.html;
              html.querySelectorAll(".shopify-block.shopify-app-block").forEach((element) => {
                const currentElement = document.getElementById(element.id);
                currentElement.parentNode.replaceChild(element, currentElement);
              });
              const contentScripts = html.querySelectorAll("[data-content-root] script[src]");
              html.querySelectorAll(":not([data-content-root]) script[src]").forEach((scriptElement) => {
                var _a4;
                const existingScript = document.head.querySelector(`script[src*="${(_a4 = scriptElement.src.split("?")[0]) == null ? void 0 : _a4.split("/").at(-1)}"]`) || [...contentScripts].includes(scriptElement);
                if (!existingScript) {
                  const newScriptTag = document.createElement("script");
                  scriptElement.getAttributeNames().forEach((name) => {
                    var _a5;
                    newScriptTag.setAttribute(name, scriptElement.getAttribute(name));
                    if (name === "src") {
                      newScriptTag.setAttribute(
                        name,
                        ((_a5 = scriptElement.src) == null ? void 0 : _a5.includes("?")) ? `${scriptElement == null ? void 0 : scriptElement.src}&v_id=${Date.now()}` : `${scriptElement == null ? void 0 : scriptElement.src}?v_id=${Date.now()}`
                      );
                    }
                  });
                  document.head.appendChild(newScriptTag);
                }
              });
              document.querySelectorAll(
                "[data-content-root] script:not(script[src],[data-product-data],[type='application/json'])"
              ).forEach((scriptElement) => {
                const newScriptTag = document.createElement("script");
                newScriptTag.innerHTML = scriptElement.innerHTML;
                scriptElement.getAttributeNames().forEach((name) => {
                  var _a4;
                  newScriptTag.setAttribute(name, scriptElement.getAttribute(name));
                  if (name === "src") {
                    newScriptTag.setAttribute(
                      name,
                      ((_a4 = scriptElement.src) == null ? void 0 : _a4.includes("?")) ? `${scriptElement == null ? void 0 : scriptElement.src}&v_id=${Date.now()}` : `${scriptElement == null ? void 0 : scriptElement.src}?v_id=${Date.now()}`
                    );
                  }
                });
                scriptElement.parentNode.replaceChild(newScriptTag, scriptElement);
              });
              document.querySelectorAll("[data-content-root] script[src]").forEach((scriptElement) => {
                const newScriptTag = document.createElement("script");
                scriptElement.getAttributeNames().forEach((name) => {
                  var _a4;
                  newScriptTag.setAttribute(name, scriptElement.getAttribute(name));
                  if (name === "src") {
                    newScriptTag.setAttribute(
                      name,
                      ((_a4 = scriptElement.src) == null ? void 0 : _a4.includes("?")) ? `${scriptElement == null ? void 0 : scriptElement.src}&v_id=${Date.now()}` : `${scriptElement == null ? void 0 : scriptElement.src}?v_id=${Date.now()}`
                    );
                  }
                });
                scriptElement.parentNode.replaceChild(newScriptTag, scriptElement);
              });
            });
          }
          if (!firstRender) {
            document.dispatchEvent(new Event("DOMContentLoaded"));
            window.dispatchEvent(new Event("DOMContentLoaded"));
            document.dispatchEvent(new CustomEvent("pageFullyLoaded", {}));
            (_g = Shopify == null ? void 0 : Shopify.PaymentButton) == null ? void 0 : _g.init();
            (_h = window == null ? void 0 : window.okeWidgetApi) == null ? void 0 : _h.initAllWidgets();
            (_i = window == null ? void 0 : window.yotpoWidgetsContainer) == null ? void 0 : _i.initWidgets();
            setTimeout(() => {
              var _a3;
              (_a3 = window == null ? void 0 : window.okeWidgetApi) == null ? void 0 : _a3.initAllWidgets();
            }, 1e3);
            setTimeout(() => {
              var _a3;
              (_a3 = window == null ? void 0 : window.okeWidgetApi) == null ? void 0 : _a3.initAllWidgets();
            }, 3e3);
          }
          firstRender = false;
        }, "afterEnter")
      }
    ]
  });
  barba.timeout = 1;
  initialized = true;
}, "initPageTransitions");

// assets/pagination.ts
var initPagination = /* @__PURE__ */ __name(() => {
}, "initPagination");
var _pagination = {
  init: /* @__PURE__ */ __name((paginationContainer, container) => {
    const paginateToUrl = /* @__PURE__ */ __name(async (url) => {
      var _a;
      if (!container) {
        return;
      }
      try {
        (_a = container == null ? void 0 : container.querySelectorAll(
          "[class^=product-card--], [class^=collection-card--], [class^=article-card--], [class^=blog-card--], [class^=page-card--]"
        )) == null ? void 0 : _a.forEach((card) => {
          var _a2;
          (_a2 = card == null ? void 0 : card.classList) == null ? void 0 : _a2.add("button-loading-transparent");
        });
        const html = await fetch(url).then((res) => res.text());
        const newDocument = new DOMParser().parseFromString(html, "text/html");
        const newContent = newDocument.querySelector(`[data-next-url][x-ref="${container == null ? void 0 : container.getAttribute("x-ref")}"]`);
        const newPagination = newDocument.querySelector(`[data-pagination][x-ref="pagination"]`);
        if (newContent) {
          container.innerHTML = newContent.innerHTML;
        }
        if (newPagination) {
          paginationContainer.innerHTML = newPagination.innerHTML;
        }
        window.scrollTo({
          top: (container == null ? void 0 : container.getBoundingClientRect().y) + window.scrollY - 260,
          behavior: "smooth"
        });
        barba.history.add(url.toString(), "barba", "replace");
      } catch (error) {
        console.error("Error loading new page:", error);
      }
    }, "paginateToUrl");
    return {
      paginateToUrl
    };
  }, "init")
};
window._pagination = _pagination;

// assets/product-data.ts
var _product = {
  hydrateProduct: /* @__PURE__ */ __name(async (product) => {
    var _a, _b, _c;
    if (!(product == null ? void 0 : product.handle) && !(product == null ? void 0 : product.id)) return null;
    if (((_b = (_a = _products[product.handle]) == null ? void 0 : _a.recommendations_loaded_at) != null ? _b : 0) > Date.now() - 1e3 * 60 * 30) {
      return _products[product.handle];
    }
    const dbKey = `_${window.Shopify.theme.id}-product--${product.handle}`;
    const data = await idbKeyval.get(dbKey);
    _products[product.handle] = {
      recommendations_loaded_at: 0,
      related_products: [],
      complementary_products: [],
      ...data || {},
      ...product,
      updated_at: Date.now()
    };
    if (!data || ((_c = data.recommendations_loaded_at) != null ? _c : 0) < Date.now() - 1e3 * 60 * 30) {
      const [related_products, complementary_products] = await Promise.all([
        fetch(`/recommendations/products?product_id=${product.id}&limit=10&section_id=data_product_json&intent=related`).then((res) => res.text()).then((text) => {
          var _a2, _b2;
          const html = document.createElement("div");
          html.innerHTML = text;
          return utils.JSONParse((_b2 = (_a2 = html.querySelector("[data-product-recommendations]")) == null ? void 0 : _a2.innerHTML) != null ? _b2 : "[]");
        }),
        fetch(`/recommendations/products?product_id=${product.id}&limit=10&section_id=data_product_json&intent=complementary`).then((res) => res.text()).then((text) => {
          var _a2, _b2;
          const html = document.createElement("div");
          html.innerHTML = text;
          return utils.JSONParse((_b2 = (_a2 = html.querySelector("[data-product-recommendations]")) == null ? void 0 : _a2.innerHTML) != null ? _b2 : "[]");
        })
      ]);
      _products[product.handle] = {
        ..._products[product.handle],
        related_products,
        complementary_products,
        recommendations_loaded_at: Date.now(),
        updated_at: Date.now()
      };
      requestIdleCallback(
        async () => {
          await idbKeyval.set(dbKey, _products[product.handle]);
          [...related_products != null ? related_products : [], ...complementary_products != null ? complementary_products : []].filter((a, i, arr) => arr.findIndex((b) => a.handle === b.handle) === i).map(async (product2) => {
            const dbKey2 = `_${window.Shopify.theme.id}-product--${product2.handle}`;
            _products[product2.handle] = {
              recommendations_loaded_at: 0,
              related_products: [],
              complementary_products: [],
              ...await (idbKeyval == null ? void 0 : idbKeyval.get(dbKey2)) || {},
              ...product2,
              updated_at: Date.now()
            };
            idbKeyval == null ? void 0 : idbKeyval.set(dbKey2, _products[product2.handle]);
          });
        },
        { timeout: 5e3 }
      );
    }
    return _products[product.handle];
  }, "hydrateProduct"),
  getHtmlProduct: /* @__PURE__ */ __name((handle) => {
    var _a, _b;
    const product = JSONParse((_a = document.querySelector(`[data-product-data="${handle}"]`)) == null ? void 0 : _a.innerHTML);
    if (product) {
      _products[handle] = {
        recommendations_loaded_at: 0,
        complementary_products: [],
        related_products: [],
        ...(_b = _products[handle]) != null ? _b : {},
        ...product,
        updated_at: Date.now()
      };
      _product.saveProduct(handle);
      return _products[handle];
    }
    return null;
  }, "getHtmlProduct"),
  getCachedProduct: /* @__PURE__ */ __name(async (handle) => {
    var _a, _b;
    const dbKey = `_${window.Shopify.theme.id}-product--${handle}`;
    const product = await idbKeyval.get(dbKey);
    if (product && ((_a = product.updated_at) != null ? _a : 0) > Date.now() - 1e3 * 60 * 30) {
      _products[handle] = {
        ...(_b = _products[handle]) != null ? _b : {},
        ...product
      };
      return _products[handle];
    }
    return null;
  }, "getCachedProduct"),
  getFetchProduct: /* @__PURE__ */ __name(async (handle, productId) => {
    var _a;
    if (!productId) return null;
    try {
      const product = await fetch(
        `/recommendations/products?product_id=${productId}&limit=10&section_id=data_product_json&intent=related&with_product_data=true`
      ).then((res) => res.text()).then((text) => {
        var _a2, _b, _c, _d;
        const html = document.createElement("div");
        html.innerHTML = text;
        const product2 = utils.JSONParse((_b = (_a2 = html.querySelector("[data-product-data]")) == null ? void 0 : _a2.innerHTML) != null ? _b : "{}");
        product2.related_products = utils.JSONParse(
          (_d = (_c = html.querySelector("[data-product-recommendations]")) == null ? void 0 : _c.innerHTML) != null ? _d : "[]"
        );
        requestIdleCallback(
          async () => {
            var _a3;
            [...(_a3 = product2.related_products) != null ? _a3 : []].filter((a, i, arr) => arr.findIndex((b) => a.handle === b.handle) === i).map(async (product3) => {
              const dbKey = `_${window.Shopify.theme.id}-product--${product3.handle}`;
              _products[product3.handle] = {
                recommendations_loaded_at: 0,
                related_products: [],
                complementary_products: [],
                ...await (idbKeyval == null ? void 0 : idbKeyval.get(dbKey)) || {},
                ...product3,
                updated_at: Date.now()
              };
              idbKeyval == null ? void 0 : idbKeyval.set(dbKey, _products[product3.handle]);
            });
          },
          { timeout: 5e3 }
        );
        product2.recommendations_loaded_at = Date.now();
        return product2;
      });
      if (product) {
        _products[handle] = {
          recommendations_loaded_at: 0,
          complementary_products: [],
          related_products: [],
          ...(_a = _products[handle]) != null ? _a : {},
          ...product,
          updated_at: Date.now()
        };
        return _products[handle];
      }
      return null;
    } catch (err) {
      return null;
    }
  }, "getFetchProduct"),
  saveProduct: /* @__PURE__ */ __name((handle, dataOverride = void 0) => {
    var _a;
    _products[handle] = {
      ...(_a = _products[handle]) != null ? _a : {},
      ...dataOverride != null ? dataOverride : {}
    };
    if (_products[handle]) {
      const dbKey = `_${window.Shopify.theme.id}-product--${handle}`;
      requestIdleCallback(
        async () => {
          await idbKeyval.set(dbKey, _products[handle]);
        },
        { timeout: 5e3 }
      );
      return _products[handle];
    }
    return null;
  }, "saveProduct"),
  getHydratedProductData: /* @__PURE__ */ __name(async (handle, productId) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!_products[handle] || ((_b = (_a = _products[handle]) == null ? void 0 : _a.recommendations_loaded_at) != null ? _b : 0) < Date.now() - 1e3 * 60 * 30) {
      _product.getHtmlProduct(handle);
    }
    if (!_products[handle] || ((_d = (_c = _products[handle]) == null ? void 0 : _c.recommendations_loaded_at) != null ? _d : 0) < Date.now() - 1e3 * 60 * 30) {
      await _product.getCachedProduct(handle);
    }
    if (!_products[handle] || ((_f = (_e = _products[handle]) == null ? void 0 : _e.recommendations_loaded_at) != null ? _f : 0) < Date.now() - 1e3 * 60 * 30) {
      if (productId) {
        await _product.getFetchProduct(handle, productId);
      }
      if (!productId) {
        await _product.getFetchProduct(handle, productId);
      }
    }
    if (!_products[handle] || ((_h = (_g = _products[handle]) == null ? void 0 : _g.recommendations_loaded_at) != null ? _h : 0) < Date.now() - 1e3 * 60 * 30) {
      return null;
    }
    _product.saveProduct(handle);
    return _products[handle];
  }, "getHydratedProductData"),
  getProductData: /* @__PURE__ */ __name(async (handle, productId) => {
    if (!_products[handle]) {
      _product.getHtmlProduct(handle);
    }
    if (!_products[handle]) {
      await _product.getCachedProduct(handle);
    }
    if (!_products[handle]) {
      await _product.getFetchProduct(handle, productId);
    }
    if (!_products[handle]) {
      return null;
    }
    _product.saveProduct(handle);
    return _products[handle];
  }, "getProductData"),
  initDynamicProductCards: /* @__PURE__ */ __name(($el, {
    targeting_type,
    target_product_handle,
    primary_source,
    fallback_source,
    product_class,
    desktop_display_limit = 50,
    mobile_display_limit = 50,
    hide_if_empty,
    content_slider,
    order_offset = 1,
    section_id,
    block_id
  }) => {
    var _a, _b;
    const container = $el.parentElement;
    const fallback_products = (_a = utils.JSONParse($el.getAttribute(`data-fallback-products`))) != null ? _a : [];
    const limit = Math.max(desktop_display_limit, mobile_display_limit);
    const product = utils.JSONParse((_b = document.querySelector(`[data-product-data="${target_product_handle}"]`)) == null ? void 0 : _b.innerHTML);
    const cart = window.Alpine.store("cart");
    const modal = window.Alpine.store("modal");
    const editor = window.Alpine.store("editor");
    const state = window.Alpine.reactive({
      product
    });
    const renderDynamicProductCards = /* @__PURE__ */ __name(async () => {
      var _a2, _b2, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r;
      content_slider == null ? void 0 : content_slider.handleResize();
      setTimeout(() => content_slider == null ? void 0 : content_slider.handleResize, 50);
      const lineItemProducts = targeting_type !== "product" ? await Promise.all((_a2 = cart.state.items) == null ? void 0 : _a2.map((item) => _product.getHydratedProductData(item.handle, item.product_id))) : [];
      const products = [];
      const complementary_products = [];
      const related_products = [];
      switch (targeting_type) {
        case "product": {
          (_c = (_b2 = state.product) == null ? void 0 : _b2.complementary_products) == null ? void 0 : _c.forEach((item) => {
            var _a3;
            if (item.id !== ((_a3 = state.product) == null ? void 0 : _a3.id)) {
              complementary_products.push(item);
            }
          });
          (_e = (_d = state.product) == null ? void 0 : _d.related_products) == null ? void 0 : _e.forEach((item) => {
            var _a3;
            if (item.id !== ((_a3 = state.product) == null ? void 0 : _a3.id)) {
              related_products.push(item);
            }
          });
          break;
        }
        case "cart_ai": {
          const expensive = [...cart.state.items].sort((a, b) => b.final_price - a.final_price).slice(0, 3);
          const recent = cart.state.items.slice(0, 2).sort((a, b) => b.final_price - a.final_price);
          (_f = [...recent, ...expensive]) == null ? void 0 : _f.forEach((line, parentIndex) => {
            var _a3, _b3;
            const product2 = lineItemProducts.find((p) => p.handle === line.handle);
            (_a3 = product2 == null ? void 0 : product2.complementary_products) == null ? void 0 : _a3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              complementary_products.push(item);
            });
            (_b3 = product2 == null ? void 0 : product2.related_products) == null ? void 0 : _b3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              related_products.push(item);
            });
          });
          break;
        }
        case "cart_most_expensive": {
          (_g = [...cart.state.items].sort((a, b) => b.final_price - a.final_price)) == null ? void 0 : _g.forEach((line, parentIndex) => {
            var _a3, _b3;
            const product2 = lineItemProducts.find((p) => p.handle === line.handle);
            (_a3 = product2 == null ? void 0 : product2.complementary_products) == null ? void 0 : _a3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              complementary_products.push(item);
            });
            (_b3 = product2 == null ? void 0 : product2.related_products) == null ? void 0 : _b3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              related_products.push(item);
            });
          });
          break;
        }
        case "cart_least_expensive": {
          (_h = [...cart.state.items].sort((a, b) => a.final_price - b.final_price)) == null ? void 0 : _h.forEach((line, parentIndex) => {
            var _a3, _b3;
            const product2 = lineItemProducts.find((p) => p.handle === line.handle);
            (_a3 = product2 == null ? void 0 : product2.complementary_products) == null ? void 0 : _a3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              complementary_products.push(item);
            });
            (_b3 = product2 == null ? void 0 : product2.related_products) == null ? void 0 : _b3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              related_products.push(item);
            });
          });
          break;
        }
        case "cart_recently_added": {
          (_i = cart.state.items) == null ? void 0 : _i.forEach((line, parentIndex) => {
            var _a3, _b3;
            const product2 = lineItemProducts.find((p) => p.handle === line.handle);
            (_a3 = product2 == null ? void 0 : product2.complementary_products) == null ? void 0 : _a3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              complementary_products.push(item);
            });
            (_b3 = product2 == null ? void 0 : product2.related_products) == null ? void 0 : _b3.forEach((item, i) => {
              if (i >= 2 || i >= 1 && parentIndex >= 2) {
                return;
              }
              related_products.push(item);
            });
          });
          break;
        }
      }
      switch (primary_source) {
        case "complementary": {
          complementary_products == null ? void 0 : complementary_products.forEach((prod) => products.push(prod));
          break;
        }
        case "related": {
          related_products == null ? void 0 : related_products.forEach((prod) => products.push(prod));
          break;
        }
        case "recently_viewed": {
          const recent_products = await Promise.all(
            (_k = (_j = window == null ? void 0 : window._recent_products) != null ? _j : []) == null ? void 0 : _k.map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
          );
          recent_products == null ? void 0 : recent_products.forEach((prod) => products.push(prod));
          break;
        }
        case "manual": {
          fallback_products == null ? void 0 : fallback_products.forEach((prod) => products.push(prod));
          break;
        }
      }
      switch (fallback_source) {
        case "complementary": {
          complementary_products == null ? void 0 : complementary_products.forEach((prod) => products.push(prod));
          break;
        }
        case "related": {
          related_products == null ? void 0 : related_products.forEach((prod) => products.push(prod));
          break;
        }
        case "recently_viewed": {
          const recent_products = await Promise.all(
            ((_l = window == null ? void 0 : window._recent_products) != null ? _l : []).map(([handle, product_id]) => _product.getHydratedProductData(handle, product_id))
          );
          recent_products == null ? void 0 : recent_products.forEach((prod) => products.push(prod));
          break;
        }
        case "manual": {
          fallback_products == null ? void 0 : fallback_products.forEach((prod) => products.push(prod));
          break;
        }
      }
      const renderProducts = (_n = (_m = products == null ? void 0 : products.filter(
        (prod) => {
          var _a3;
          return targeting_type === "product" ? prod && prod.id !== ((_a3 = state == null ? void 0 : state.product) == null ? void 0 : _a3.id) : !cart.state.items.some((item) => item.product_id === (prod == null ? void 0 : prod.id));
        }
      )) == null ? void 0 : _m.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)) != null ? _n : [];
      const validFallbackProducts = (_p = (_o = fallback_products == null ? void 0 : fallback_products.filter(
        (prod) => {
          var _a3;
          return targeting_type === "product" ? prod && prod.id !== ((_a3 = state == null ? void 0 : state.product) == null ? void 0 : _a3.id) : !cart.state.items.some((item) => item.product_id === (prod == null ? void 0 : prod.id));
        }
      )) == null ? void 0 : _o.filter((a, i, arr) => arr.findIndex((b) => b.id === a.id) === i)) != null ? _p : [];
      switch (hide_if_empty) {
        case "none":
          if ((renderProducts == null ? void 0 : renderProducts.length) === 0 && (validFallbackProducts == null ? void 0 : validFallbackProducts.length)) {
            validFallbackProducts.forEach((prod) => renderProducts.push(prod));
          }
          break;
        case "section":
          (_q = container.closest(`.shopify-section`)) == null ? void 0 : _q.classList.toggle("!hidden", (renderProducts == null ? void 0 : renderProducts.length) === 0);
          break;
        case "container":
          (_r = container.closest(`[data-style-id]:not([data-style-id="${container.getAttribute("data-style-id")}"])`)) == null ? void 0 : _r.classList.toggle("!hidden", (renderProducts == null ? void 0 : renderProducts.length) === 0);
          break;
        case "block":
          break;
      }
      const existingItems = container.querySelectorAll(`[data-render-index*="${block_id}--"]`);
      const controlProducts = renderProducts == null ? void 0 : renderProducts.filter(
        (prod, index) => !container.querySelector(`[data-render-index="${block_id}--${index}"][data-product-handle="${prod.handle}"]`)
      );
      if (!controlProducts.length && existingItems.length === (renderProducts == null ? void 0 : renderProducts.length)) {
        return;
      }
      existingItems.forEach((el) => el.remove());
      renderProducts.slice(0, limit).forEach((prod, i, arr) => {
        var _a3;
        const node = (_a3 = document.querySelector(`[data-product-card='${product_class}']`)) == null ? void 0 : _a3.cloneNode(true);
        if (node) {
          const div = document.createElement("div");
          div.setAttribute("data-product-handle", prod.handle);
          div.setAttribute("data-style-id", `${section_id}--${block_id}`);
          div.setAttribute("data-render-index", `${block_id}--${i}`);
          div.setAttribute(
            "class",
            `shrink-0 max-w-full w-full order-[--order] ${i > desktop_display_limit ? "mobile-only" : i > mobile_display_limit ? "desktop-tablet-only" : ""}`
          );
          div.style.setProperty("--order", `${(i + order_offset) * 10}`);
          node.removeAttribute(`data-product-card`);
          node.setAttribute("data-product-handle", prod.handle);
          node.setAttribute("data-product-id", `${prod.id}`);
          node.querySelectorAll("[data-loop-item], [data-x-if], style").forEach((el) => el.remove());
          div.appendChild(node);
          container.appendChild(div);
        }
      });
      content_slider == null ? void 0 : content_slider.handleResize();
    }, "renderDynamicProductCards");
    renderDynamicProductCards();
    if (targeting_type === "product") {
      Alpine.effect(() => {
        var _a2, _b2, _c;
        if (((_a2 = state.product) == null ? void 0 : _a2.recommendations_loaded_at) || ((_c = (_b2 = state.product) == null ? void 0 : _b2.complementary_products) == null ? void 0 : _c.length)) {
          renderDynamicProductCards();
        }
      });
    }
    if (targeting_type !== "product") {
      Alpine.effect(() => {
        const show = !container.closest("[data-dynamic-modals]") || (editor == null ? void 0 : editor.select_section_id) === section_id || modal.id === "modal--cart-drawer";
        if ((cart.state.total_price || cart.state.item_count || cart.state.item_count <= 0) && show) {
          renderDynamicProductCards();
        }
      });
    }
    _product.getHydratedProductData(product == null ? void 0 : product.handle, product == null ? void 0 : product.id).then((res) => {
      var _a2;
      state.product = ((_a2 = state.product) == null ? void 0 : _a2.handle) === (res == null ? void 0 : res.handle) ? res : state.product;
    });
  }, "initDynamicProductCards"),
  lastOptions: {}
};
window._product = _product;
var initProductData = /* @__PURE__ */ __name(() => {
}, "initProductData");

// assets/product-drawer.ts
var initProductDrawer = /* @__PURE__ */ __name(() => {
  window.Alpine.store("productDrawer", {
    show: false,
    product: _products[Object.keys(_products)[0]],
    showProductDrawer({ product = _products[Object.keys(_products)[0]] }) {
      this.product = product;
      this.show = true;
    }
  });
  const productDrawerStore = window.Alpine.store("productDrawer");
  window.Alpine.magic("productDrawer", () => productDrawerStore);
  window._stores["productDrawer"] = productDrawerStore;
}, "initProductDrawer");

// assets/quick-view.ts
var initQuickView = /* @__PURE__ */ __name(() => {
  window.Alpine.store("quickView", {
    show: false,
    loading: false,
    handle: "",
    dynamic_popups: [],
    async renderQuickView(handle, $data, bundleButton, variantId) {
      var _a, _b, _c, _d, _e;
      const container = document.querySelector("[data-quick-view-container]");
      const view_buttons = document.querySelectorAll("[data-quick-view-show-more]");
      const loading_container = document.querySelector("[data-quick-view-loading]");
      this.handle = handle;
      this.show = true;
      loading_container.classList.remove("opacity-0", "pointer-events-none");
      if (!handle || !container || container.querySelector(`form[data-handle="${handle}"]`)) return;
      const cacheKey = `${window.location.origin}/products/${handle}`;
      let cache = barba.cache.get(cacheKey);
      if (!(cache == null ? void 0 : cache.request)) {
        const keys = await idbKeyval.keys();
        const key = keys.find((key2) => key2.includes(cacheKey));
        if (key) {
          cache = barba.cache.set(cacheKey, (_a = idbKeyval == null ? void 0 : idbKeyval.get(key)) == null ? void 0 : _a.then((res) => res == null ? void 0 : res.data), "prefetch");
        }
      }
      if (!(cache == null ? void 0 : cache.request)) {
        const data = fetch(cacheKey, { cache: "force-cache" }).then((res) => res.text()).then((html2) => ({
          html: html2,
          url: { hash: void 0, href: cacheKey, path: `/products/${handle}` }
        }));
        cache = barba.cache.set(cacheKey, data, "prefetch");
        document.dispatchEvent(new CustomEvent("barba:prefetch:fulfilled", { detail: { url: cacheKey } }));
      }
      let request = await (cache == null ? void 0 : cache.request);
      let html = request == null ? void 0 : request.html;
      if (!html) {
        const data = fetch(cacheKey, { cache: "force-cache" }).then((res) => res.text()).then((html2) => ({
          html: html2,
          url: { hash: void 0, href: cacheKey, path: `/products/${handle}` }
        }));
        cache = barba.cache.set(cacheKey, data, "prefetch");
        request = await (cache == null ? void 0 : cache.request);
        html = request == null ? void 0 : request.html;
        document.dispatchEvent(new CustomEvent("barba:prefetch:fulfilled", { detail: { url: cacheKey } }));
      }
      const div = document.createElement("div");
      div.innerHTML = html;
      const productData = div.querySelector(`[data-product-data="${handle}"]`);
      div.querySelectorAll("[data-popup]").forEach((popup) => {
        document.body.appendChild(popup);
        this.dynamic_popups.push(popup);
      });
      const formElement = div.querySelector(`[data-content-root] [data-section-type="main_product"]`);
      (_b = formElement == null ? void 0 : formElement.classList) == null ? void 0 : _b.add("lg:!p-12", "!p-6", "!absolute", "!inset-0", "overflow-y-auto", "scrollbar-none");
      (_c = formElement == null ? void 0 : formElement.parentElement) == null ? void 0 : _c.querySelectorAll("form > div[data-style-id]").forEach((child) => {
        child.classList.add("lg:!sticky", "lg:!top-0", "!h-max");
      });
      const header = document.createElement("header");
      header.classList.add("lg:hidden", "flex", "flex-col");
      formElement.querySelectorAll('[data-quick-view-visibility="mobile_header"]').forEach((node) => {
        const clonedNode = node.cloneNode(true);
        clonedNode.removeAttribute("data-quick-view-visibility");
        header.appendChild(clonedNode);
      });
      formElement.prepend(header);
      formElement.setAttribute("data-quick-view", "true");
      (_d = loading_container == null ? void 0 : loading_container.classList) == null ? void 0 : _d.add("opacity-0", "pointer-events-none");
      container.innerHTML = productData.outerHTML + ((_e = formElement == null ? void 0 : formElement.parentElement) == null ? void 0 : _e.innerHTML);
      if ($data && bundleButton && formElement) {
        formElement.querySelectorAll('[data-block-type="quantity_selector"], [data-block-type="complementary_products"]').forEach((el) => {
          el.remove();
        });
        formElement.querySelectorAll(`[data-block-type="add_to_cart_button"]`).forEach((element) => {
          const clonedBundleButton = bundleButton.cloneNode(true);
          element.innerHTML = "";
          element.appendChild(clonedBundleButton);
        });
        Alpine.nextTick(() => {
          var _a2;
          (_a2 = formElement._x_dataStack) == null ? void 0 : _a2.forEach((proxyState) => {
            if ((proxyState == null ? void 0 : proxyState.card) && (proxyState == null ? void 0 : proxyState.bundle) && (proxyState == null ? void 0 : proxyState.state)) {
              proxyState.card = proxyState.state;
              proxyState.bundle = $data.bundle;
            }
          });
        });
      }
      if (variantId) {
        Alpine.nextTick(() => {
          var _a2;
          (_a2 = formElement._x_dataStack) == null ? void 0 : _a2.forEach((proxyState) => {
            if ((proxyState == null ? void 0 : proxyState.state) && proxyState.setSelectedVariant) {
              proxyState.setSelectedVariant(+variantId);
            }
          });
        });
      }
      view_buttons == null ? void 0 : view_buttons.forEach((link) => {
        link.href = `${window.location.origin}/products/${handle}`;
      });
    }
  });
  const quickViewStore = window.Alpine.store("quickView");
  const handleKeydown = /* @__PURE__ */ __name((e) => {
    if (e.key === "Escape") {
      quickViewStore.show = false;
    }
  }, "handleKeydown");
  window.Alpine.effect(() => {
    var _a;
    document.body.classList.toggle("!overflow-hidden", quickViewStore.show);
    if (quickViewStore.show) {
      document.addEventListener("keydown", handleKeydown);
    }
    if (!quickViewStore.show) {
      document.removeEventListener("keydown", handleKeydown);
      (_a = quickViewStore.dynamic_popups) == null ? void 0 : _a.forEach((element) => {
        element.remove();
      });
      quickViewStore.dynamic_popups = [];
    }
  });
  window.Alpine.magic("quickView", () => quickViewStore);
  window._stores["quickView"] = quickViewStore;
}, "initQuickView");

// assets/scrollbar.ts
var initScrollBar = /* @__PURE__ */ __name(() => {
}, "initScrollBar");
var _scrollbar = {
  init: /* @__PURE__ */ __name((bar, thumb, container, scroll_speed = 150) => {
    var _a, _b, _c, _d, _e, _f;
    const findScrollContainer = /* @__PURE__ */ __name((element) => {
      var _a2, _b2;
      return ((_a2 = element == null ? void 0 : element.parentElement) == null ? void 0 : _a2.querySelector('[x-ref="scrollContainer"]')) || ((_b2 = element == null ? void 0 : element.parentElement) == null ? void 0 : _b2.querySelector('[x-ref^="scrollColors"]')) || findScrollContainer(element.parentElement);
    }, "findScrollContainer");
    if (bar && !container) {
      container = findScrollContainer(bar);
    }
    const state = window.Alpine.reactive({
      current_index: Math.max(
        1,
        Math.min(
          (_b = [...(_a = container == null ? void 0 : container.children) != null ? _a : []]) == null ? void 0 : _b.filter(
            (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
          ).length,
          ((_d = [...(_c = container == null ? void 0 : container.children) != null ? _c : []]) == null ? void 0 : _d.filter((child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none").findIndex((child) => {
            const center = (container == null ? void 0 : container.clientWidth) / 2 + (container == null ? void 0 : container.scrollLeft);
            const start = (container == null ? void 0 : container.scrollLeft) + +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0");
            if ((container == null ? void 0 : container.children.length) > Math.round((container == null ? void 0 : container.scrollWidth) / (container == null ? void 0 : container.clientWidth) * 100) / 100) {
              return child.offsetLeft - 5 <= start && child.offsetLeft + child.clientWidth > start;
            }
            return child.offsetLeft < center && child.offsetLeft + child.clientWidth > center;
          })) + 1
        )
      ),
      pages: (_f = [...(_e = container == null ? void 0 : container.children) != null ? _e : []]) == null ? void 0 : _f.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
      ).length,
      width: (container == null ? void 0 : container.clientWidth) / (container == null ? void 0 : container.scrollWidth) * 100,
      left: (container == null ? void 0 : container.scrollLeft) / (container == null ? void 0 : container.scrollWidth) * bar.clientWidth / bar.clientWidth,
      manual_scroll: false,
      no_next_page: (container == null ? void 0 : container.scrollLeft) + (container == null ? void 0 : container.clientWidth) + 25 >= (container == null ? void 0 : container.scrollWidth)
    });
    const calculatePosition = /* @__PURE__ */ __name(() => {
      var _a2, _b2, _c2;
      const children = [...(_a2 = container == null ? void 0 : container.children) != null ? _a2 : []].filter((el) => el.tagName !== "STYLE");
      state.current_index = Math.max(
        1,
        Math.min(
          (children == null ? void 0 : children.filter(
            (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none"
          ).length) - 1,
          ((_c2 = (_b2 = children == null ? void 0 : children.filter((child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none")) == null ? void 0 : _b2.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order)) == null ? void 0 : _c2.findIndex((child, i, arr) => {
            const center = (container == null ? void 0 : container.clientWidth) / 2 + (container == null ? void 0 : container.scrollLeft);
            const start = (container == null ? void 0 : container.scrollLeft) + +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0");
            if (arr.length > Math.round((container == null ? void 0 : container.scrollWidth) / (container == null ? void 0 : container.clientWidth) * 100) / 100) {
              return child.offsetLeft - 5 <= start && child.offsetLeft + child.clientWidth > start;
            }
            return child.offsetLeft < center && child.offsetLeft + child.clientWidth > center;
          })) + 1
        )
      );
      if ((container == null ? void 0 : container.scrollLeft) + (container == null ? void 0 : container.clientWidth) + 10 >= (container == null ? void 0 : container.scrollWidth)) {
        if ((container == null ? void 0 : container.scrollWidth) - state.current_index * (container == null ? void 0 : container.clientWidth) > 20) {
          state.current_index += 1;
        }
      }
      state.pages = children == null ? void 0 : children.filter((child) => getComputedStyle(child).display !== "none").length;
      state.width = (container == null ? void 0 : container.clientWidth) / (container == null ? void 0 : container.scrollWidth);
      state.left = (container == null ? void 0 : container.scrollLeft) / (container == null ? void 0 : container.scrollWidth) * bar.clientWidth / bar.clientWidth;
      state.no_next_page = state.current_index === state.pages || (container == null ? void 0 : container.scrollLeft) + (container == null ? void 0 : container.clientWidth) + 25 >= (container == null ? void 0 : container.scrollWidth);
    }, "calculatePosition");
    const handleScrollBarClick = /* @__PURE__ */ __name((e, content_slider) => {
      const percentage = (e.clientX - bar.getBoundingClientRect().left) / bar.clientWidth - state.width / 2 * bar.clientWidth / bar.clientWidth;
      if (content_slider == null ? void 0 : content_slider.state) {
        content_slider.state.block_scroll_events = true;
      }
      container == null ? void 0 : container.scrollTo({
        left: percentage * (container == null ? void 0 : container.scrollWidth),
        behavior: "instant"
      });
      if (content_slider == null ? void 0 : content_slider.state) {
        content_slider.state.block_scroll_events = false;
      }
      calculatePosition();
    }, "handleScrollBarClick");
    const handleScrollThumbPointerDown = /* @__PURE__ */ __name((e, content_slider) => {
      if (!container) return;
      container.style.scrollSnapType = "none";
      const startX = e.clientX;
      const startLeft = state.left * bar.clientWidth;
      document.body.classList.add("[&_*]:!cursor-grabbing");
      thumb.classList.add("active");
      if (content_slider == null ? void 0 : content_slider.state) {
        content_slider.state.block_scroll_events = true;
      }
      const handleDocumentPointerMove = /* @__PURE__ */ __name((e2) => {
        const percentage = Math.max(0, Math.min(1, (startLeft + e2.clientX - startX) / bar.clientWidth));
        container == null ? void 0 : container.scrollTo({
          left: percentage * (container == null ? void 0 : container.scrollWidth),
          behavior: "instant"
        });
        calculatePosition();
      }, "handleDocumentPointerMove");
      const handleDocumentPointerUp = /* @__PURE__ */ __name((e2) => {
        removeEventListeners();
      }, "handleDocumentPointerUp");
      const removeEventListeners = /* @__PURE__ */ __name(() => {
        document.body.classList.remove("[&_*]:!cursor-grabbing");
        thumb.classList.remove("active");
        container.style.scrollSnapType = "";
        document.removeEventListener("pointermove", handleDocumentPointerMove);
        document.removeEventListener("pointerup", handleDocumentPointerUp);
        if (content_slider == null ? void 0 : content_slider.state) {
          content_slider.state.block_scroll_events = false;
        }
      }, "removeEventListeners");
      document.addEventListener("pointermove", handleDocumentPointerMove);
      document.addEventListener("pointerup", handleDocumentPointerUp);
    }, "handleScrollThumbPointerDown");
    const handlePrevClick = /* @__PURE__ */ __name((e, content_slider) => {
      var _a2, _b2, _c2, _d2;
      if (!container) return;
      container.style.scrollSnapType = "none";
      if (content_slider == null ? void 0 : content_slider.state) {
        content_slider.state.block_scroll_events = true;
      }
      const activeChildren = (_b2 = [...(_a2 = container == null ? void 0 : container.children) != null ? _a2 : []]) == null ? void 0 : _b2.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none" && child.tagName !== "STYLE"
      );
      const index = Math.max(0, state.current_index - 2 < 0 ? (activeChildren == null ? void 0 : activeChildren.length) - 1 : state.current_index - 2);
      const sortedActiveChildren = activeChildren == null ? void 0 : activeChildren.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
      sortedActiveChildren.forEach((child, i) => {
        child.classList.toggle("scroll-active", i === index);
      });
      utils.scrollToX(
        scroll_speed,
        ((_d2 = (_c2 = sortedActiveChildren[index]) == null ? void 0 : _c2.offsetLeft) != null ? _d2 : 0) - +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0"),
        container,
        () => {
          container.style.scrollSnapType = "";
          calculatePosition();
          if (content_slider == null ? void 0 : content_slider.state) {
            content_slider.state.block_scroll_events = false;
            content_slider == null ? void 0 : content_slider.handleScroll();
            content_slider == null ? void 0 : content_slider.handleInfiniteScroll();
          }
        }
      );
    }, "handlePrevClick");
    const handleNextClick = /* @__PURE__ */ __name((e, content_slider) => {
      var _a2, _b2, _c2, _d2;
      if (!container) return;
      container.style.scrollSnapType = "none";
      if (content_slider == null ? void 0 : content_slider.state) {
        content_slider.state.block_scroll_events = true;
      }
      const activeChildren = (_b2 = [...(_a2 = container == null ? void 0 : container.children) != null ? _a2 : []]) == null ? void 0 : _b2.filter(
        (child) => getComputedStyle(child).display !== "none" && getComputedStyle(child).scrollSnapAlign !== "none" && child.tagName !== "STYLE"
      );
      const sortedActiveChildren = activeChildren == null ? void 0 : activeChildren.toSorted((a, b) => +getComputedStyle(a).order - +getComputedStyle(b).order);
      let found = false;
      const target = (_c2 = sortedActiveChildren.find((el) => {
        if (found) {
          el.classList.add("scroll-active");
          return true;
        }
        if (el.classList.contains("scroll-active")) {
          el.classList.remove("scroll-active");
          found = true;
        }
        return false;
      })) != null ? _c2 : sortedActiveChildren[1];
      utils.scrollToX(
        scroll_speed,
        ((_d2 = target == null ? void 0 : target.offsetLeft) != null ? _d2 : 0) - +getComputedStyle(container).scrollPaddingLeft.replace("px", "").replace("auto", "0"),
        container,
        () => {
          container.style.scrollSnapType = "";
          calculatePosition();
          if (content_slider == null ? void 0 : content_slider.state) {
            content_slider.state.block_scroll_events = false;
            content_slider == null ? void 0 : content_slider.handleScroll();
            content_slider == null ? void 0 : content_slider.handleInfiniteScroll();
          }
        }
      );
    }, "handleNextClick");
    container == null ? void 0 : container.addEventListener("scroll", (e) => {
      calculatePosition();
    });
    const mutationObserver = new MutationObserver((e) => {
      calculatePosition();
    });
    mutationObserver.observe(container, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class", "style"]
    });
    const resizeObserver = new ResizeObserver((e) => {
      calculatePosition();
    });
    resizeObserver.observe(container, { box: "content-box" });
    calculatePosition();
    return {
      handleScrollBarClick,
      handleScrollThumbPointerDown,
      handlePrevClick,
      handleNextClick,
      scrollbar: state,
      containerRef: container
    };
  }, "init"),
  initScrollPagination: /* @__PURE__ */ __name(($el, container) => {
    var _a, _b, _c;
    const findScrollContainer = /* @__PURE__ */ __name((element) => {
      var _a2;
      return ((_a2 = element == null ? void 0 : element.parentElement) == null ? void 0 : _a2.querySelector('[x-ref="scrollContainer"]')) || findScrollContainer(element.parentElement);
    }, "findScrollContainer");
    if ($el && !container) {
      container = findScrollContainer($el);
    }
    const content_slider = (_c = (_b = (_a = container == null ? void 0 : container.closest('[x-data*="initContentSlider"]')) == null ? void 0 : _a._x_dataStack) == null ? void 0 : _b.find((state) => state["content_slider"])) == null ? void 0 : _c.content_slider;
    return {
      containerRef: container,
      content_slider: content_slider != null ? content_slider : {}
    };
  }, "initScrollPagination")
};
window._scrollbar = _scrollbar;

// assets/smooth-scroll.ts
var initSmoothScroll = /* @__PURE__ */ __name(() => {
  const elements = /* @__PURE__ */ new Set();
  const scrollToElementByTargetId = /* @__PURE__ */ __name((id) => {
    var _a, _b, _c, _d, _e, _f;
    let target = document.getElementById(id);
    if (!target) {
      return;
    }
    if (utils.isElementScrollable(target.parentElement) && utils.isVisible(target.parentElement) && utils.isInViewport(target)) {
      if (target.parentElement.scrollWidth > target.parentElement.offsetWidth) {
        utils.scrollToXY(260, target.offsetLeft, (_a = target.parentElement) == null ? void 0 : _a.scrollTop, target.parentElement);
      }
      if (target.parentElement.scrollHeight > target.parentElement.offsetHeight) {
        utils.scrollToXY(260, (_b = target.parentElement) == null ? void 0 : _b.scrollLeft, target.offsetTop, target.parentElement);
      }
      return;
    }
    if (target.hasAttribute("data-tab-id")) {
      target = target.closest(".shopify-section");
    }
    const targetPosition = ((_c = utils.getElementPosition(target)) == null ? void 0 : _c.top) - Math.max(0, (_f = (_e = (_d = document.querySelector(".header-sections-container")) == null ? void 0 : _d.getBoundingClientRect()) == null ? void 0 : _e.bottom) != null ? _f : 0);
    utils.scrollToY(260 + Math.min(Math.abs(Math.round((window.scrollY - targetPosition) / 15)), 500), targetPosition);
  }, "scrollToElementByTargetId");
  const initEvents = /* @__PURE__ */ __name((target = document) => {
    const links = target.querySelectorAll(
      `[href*="#"]:not([href*="#modal--"], [href*="#popup--"], [href*="#drawer--"], use)`
    );
    links.forEach((link) => {
      var _a, _b, _c, _d;
      if (typeof link.href !== "string") {
        return;
      }
      if (elements.has(link)) {
        return;
      }
      elements.add(link);
      if (utils.isExternalURL(link.href)) {
        return;
      }
      const id = (_d = (_c = (_b = (_a = link == null ? void 0 : link.href) == null ? void 0 : _a.split("#")) == null ? void 0 : _b.at(1)) == null ? void 0 : _c.split(/[?&]/)) == null ? void 0 : _d.at(0);
      const target2 = document.getElementById(id);
      if (!target2) {
        return;
      }
      link.onclick = () => {
        scrollToElementByTargetId(id);
      };
    });
  }, "initEvents");
  const mutationObserver = new MutationObserver((e) => {
    e == null ? void 0 : e.forEach((record) => {
      var _a;
      const nodes = [];
      if (((_a = record == null ? void 0 : record.addedNodes) == null ? void 0 : _a.length) && (record == null ? void 0 : record.target) instanceof Element) {
        initEvents(record.target);
      }
    });
  });
  mutationObserver.observe(document.body, { childList: true, subtree: true });
  if (window.location.hash) {
    scrollToElementByTargetId(window.location.hash.replace(/#/gi, ""));
  }
  initEvents();
}, "initSmoothScroll");

// assets/toast.ts
var initToast = /* @__PURE__ */ __name(() => {
  window.Alpine.store("toast", {
    toasts: [],
    paused: false,
    interval: null,
    addToast: /* @__PURE__ */ __name(function({ type = "plain", target = "generic", timestamp = Date.now(), title, content, icon, hide = 0 }) {
      const defaultIcon = {
        plain: "bolt",
        warning: "warning-triangle",
        error: "error-circle",
        info: "info-circle",
        success: "check-circle"
      }[type];
      this.toasts.push({
        type,
        target,
        timestamp,
        title,
        content,
        icon: icon || defaultIcon,
        hide
      });
      this.toasts = this.toasts.filter((a, i, arr) => arr.findIndex((b) => a.title === b.title && a.content === b.content) === i);
    }, "addToast"),
    removeAllToasts: /* @__PURE__ */ __name(function() {
      this.toasts = [];
    }, "removeAllToasts"),
    pauseRemoval: /* @__PURE__ */ __name(function() {
      this.paused = true;
      clearInterval(this.interval);
      this.interval = null;
    }, "pauseRemoval"),
    continueRemoval: /* @__PURE__ */ __name(function() {
      this.paused = false;
    }, "continueRemoval")
  });
  const toastStore = window.Alpine.store("toast");
  window.Alpine.magic("toast", () => toastStore);
  window.Alpine.effect(() => {
    if (toastStore.toasts.length && !toastStore.interval && !toastStore.paused) {
      toastStore.interval = setInterval(() => {
        const checkTimestamp = Date.now() - 3e3;
        toastStore.toasts = toastStore.toasts.map((toast) => ({
          ...toast,
          hide: toast.timestamp < checkTimestamp ? Date.now() : 0
        }));
        if (toastStore.toasts.every((toast) => toast.hide && toast.hide > 500)) {
          toastStore.toasts = [];
        }
      }, 500);
    }
    if (toastStore.interval && !toastStore.toasts.length) {
      clearInterval(toastStore.interval);
      toastStore.interval = null;
    }
  });
  window._stores["toast"] = toastStore;
}, "initToast");

// assets/tooltip.ts
var initTooltip = /* @__PURE__ */ __name(() => {
  const container = document.querySelector("[data-tooltip-container]");
  window.Alpine.store("tooltip", {
    tooltips: /* @__PURE__ */ new Map(),
    async addTooltip(element, content, position = "top") {
      const currentTooltip = this.tooltips.get(element);
      if (!currentTooltip) {
        const parents = utils.findAllScrollableParents(element);
        const tooltipElement = document.createElement("div");
        tooltipElement.innerHTML = content;
        const handleUpdateCoordinates = /* @__PURE__ */ __name(() => {
          const { top, left, right, width, height, bottom } = element.getBoundingClientRect();
          tooltipElement.classList.add("active");
          if (position === "top") {
            tooltipElement.style.top = `${top}px`;
            tooltipElement.style.left = `${left + width / 2}px`;
          }
          if (position === "bottom") {
            tooltipElement.style.top = `${bottom}px`;
            tooltipElement.style.left = `${left + width / 2}px`;
          }
          if (position === "left") {
            tooltipElement.style.top = `${top + height / 2}px`;
            tooltipElement.style.left = `${left}px`;
          }
          if (position === "right") {
            tooltipElement.style.top = `${top + height / 2}px`;
            tooltipElement.style.left = `${right}px`;
          }
        }, "handleUpdateCoordinates");
        this.tooltips.set(element, {
          tooltip: tooltipElement,
          timeout: null,
          handleUpdateCoordinates,
          scrollParents: parents
        });
        container.appendChild(tooltipElement);
        tooltipElement.classList.add("tooltip", `tooltip--${position}`);
        await utils.delay(1);
        handleUpdateCoordinates();
        parents.forEach((parent) => {
          parent.addEventListener("scroll", handleUpdateCoordinates);
        });
      }
      if (currentTooltip) {
        clearTimeout(currentTooltip.timeout);
        currentTooltip.timeout = null;
      }
    },
    async removeTooltip(element) {
      const currentTooltip = this.tooltips.get(element);
      if (currentTooltip) {
        const tooltip = currentTooltip.tooltip;
        currentTooltip.timeout = setTimeout(async () => {
          tooltip.classList.remove("active");
          this.tooltips.delete(element);
          tooltip.ontransitionend = (event) => {
            tooltip.remove();
          };
        }, 50);
      }
    }
  });
  const tooltipStore = window.Alpine.store("tooltip");
  window.Alpine.magic("tooltip", () => tooltipStore);
  window._stores["tooltip"] = tooltipStore;
}, "initTooltip");

// assets/theme.ts
window.utils = utils_default;
document.dispatchEvent(new CustomEvent("theme:utils:loaded"));
(() => {
  window.onerror = function(...args) {
    return (args == null ? void 0 : args[0]) === "Script error.";
  };
  window.onunhandledrejection = function(event) {
    console.warn("\u{1F6A8} Unhandled Promise Rejection:", event.reason);
  };
  const origConsoleWarn = console.warn;
  window.console.warn = function(...args) {
    var _a;
    if ((_a = args == null ? void 0 : args[0]) == null ? void 0 : _a.includes("Alpine Expression Error")) {
      const [message, ...rest] = args;
      console.error(
        `%cAlpine JS Error:%c 

${message == null ? void 0 : message.replaceAll("\n\n", "\n")}
`,
        "color: red; font-size: 17px; font-weight: 600;",
        "font-weight: 600; font-size: 14px;",
        ...rest
      );
      return;
    }
    return origConsoleWarn.apply(this, args);
  };
})();
var initTheme = /* @__PURE__ */ __name(() => {
  window.Alpine.store("editor", {
    load_section_id: "",
    unload_section_id: "",
    select_section_id: "",
    reorder_section_id: "",
    select_block_id: "",
    inspector: false,
    setValue(key, value) {
      this[key] = value;
    }
  });
  const editor = window.Alpine.store("editor");
  window.Alpine.magic("editor", () => editor);
  initModals();
  initAccessibility();
  initQuickView();
  initProductDrawer();
  initCart();
  initProductData();
  initScrollBar();
  initTextarea();
  initTooltip();
  initToast();
  initSearch();
  initMediaGallery();
  initBackInStockNotification();
  initSmoothScroll();
  initPageTransitions();
  initPagination();
  initCSSAutoPrefixer();
  if (window.design_mode) {
    document.dispatchEvent(new CustomEvent("theme:editor:init"));
  }
  document.dispatchEvent(new CustomEvent("theme:init"));
}, "initTheme");
document.addEventListener("alpine:init", initTheme);
export {
  initTheme
};

// random_comment  